/* eslint-disable */
(function (a, b) {
  typeof exports === 'object' && typeof module !== 'undefined'
    ? b(exports)
    : typeof define === 'function' && define.amd
    ? define(['exports'], b)
    : b((a.JSEncrypt = {}));
})(this, function (A) {
  'use strict';
  var G = '0123456789abcdefghijklmnopqrstuvwxyz';
  function int2char(n) {
    return G.charAt(n);
  }
  function op_and(x, y) {
    return x & y;
  }
  function op_or(x, y) {
    return x | y;
  }
  function op_xor(x, y) {
    return x ^ y;
  }
  function op_andnot(x, y) {
    return x & ~y;
  }
  function lbit(x) {
    if (x == 0) {
      return -1;
    }
    var r = 0;
    if ((x & 0xffff) == 0) {
      x >>= 16;
      r += 16;
    }
    if ((x & 0xff) == 0) {
      x >>= 8;
      r += 8;
    }
    if ((x & 0xf) == 0) {
      x >>= 4;
      r += 4;
    }
    if ((x & 3) == 0) {
      x >>= 2;
      r += 2;
    }
    if ((x & 1) == 0) {
      ++r;
    }
    return r;
  }
  function cbit(x) {
    var r = 0;
    while (x != 0) {
      x &= x - 1;
      ++r;
    }
    return r;
  }
  var H = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
  var I = '=';
  function hex2b64(h) {
    var i;
    var c;
    var a = '';
    for (i = 0; i + 3 <= h.length; i += 3) {
      c = parseInt(h.substring(i, i + 3), 16);
      a += H.charAt(c >> 6) + H.charAt(c & 63);
    }
    if (i + 1 == h.length) {
      c = parseInt(h.substring(i, i + 1), 16);
      a += H.charAt(c << 2);
    } else if (i + 2 == h.length) {
      c = parseInt(h.substring(i, i + 2), 16);
      a += H.charAt(c >> 2) + H.charAt((c & 3) << 4);
    }
    while ((a.length & 3) > 0) {
      a += I;
    }
    return a;
  }
  function b64tohex(s) {
    var a = '';
    var i;
    var k = 0;
    var b = 0;
    for (i = 0; i < s.length; ++i) {
      if (s.charAt(i) == I) {
        break;
      }
      var v = H.indexOf(s.charAt(i));
      if (v < 0) {
        continue;
      }
      if (k == 0) {
        a += int2char(v >> 2);
        b = v & 3;
        k = 1;
      } else if (k == 1) {
        a += int2char((b << 2) | (v >> 4));
        b = v & 0xf;
        k = 2;
      } else if (k == 2) {
        a += int2char(b);
        a += int2char(v >> 2);
        b = v & 3;
        k = 3;
      } else {
        a += int2char((b << 2) | (v >> 4));
        a += int2char(v & 0xf);
        k = 0;
      }
    }
    if (k == 1) {
      a += int2char(b << 2);
    }
    return a;
  }
  var J = function (d, b) {
    J =
      Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array &&
        function (d, b) {
          d.__proto__ = b;
        }) ||
      function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
      };
    return J(d, b);
  };
  function __extends(d, b) {
    J(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype =
      b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
  }
  var K;
  var L = {
    decode: function (a) {
      var i;
      if (K === undefined) {
        var b = '0123456789ABCDEF';
        var d = ' \f\n\r\t\u00A0\u2028\u2029';
        K = {};
        for (i = 0; i < 16; ++i) {
          K[b.charAt(i)] = i;
        }
        b = b.toLowerCase();
        for (i = 10; i < 16; ++i) {
          K[b.charAt(i)] = i;
        }
        for (i = 0; i < d.length; ++i) {
          K[d.charAt(i)] = -1;
        }
      }
      var e = [];
      var f = 0;
      var g = 0;
      for (i = 0; i < a.length; ++i) {
        var c = a.charAt(i);
        if (c == '=') {
          break;
        }
        c = K[c];
        if (c == -1) {
          continue;
        }
        if (c === undefined) {
          throw new Error('Illegal character at offset ' + i);
        }
        f |= c;
        if (++g >= 2) {
          e[e.length] = f;
          f = 0;
          g = 0;
        } else {
          f <<= 4;
        }
      }
      if (g) {
        throw new Error('Hex encoding incomplete: 4 bits missing');
      }
      return e;
    },
  };
  var M;
  var O = {
    decode: function (a) {
      var i;
      if (M === undefined) {
        var b =
          'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
        var d = '= \f\n\r\t\u00A0\u2028\u2029';
        M = Object.create(null);
        for (i = 0; i < 64; ++i) {
          M[b.charAt(i)] = i;
        }
        for (i = 0; i < d.length; ++i) {
          M[d.charAt(i)] = -1;
        }
      }
      var e = [];
      var f = 0;
      var g = 0;
      for (i = 0; i < a.length; ++i) {
        var c = a.charAt(i);
        if (c == '=') {
          break;
        }
        c = M[c];
        if (c == -1) {
          continue;
        }
        if (c === undefined) {
          throw new Error('Illegal character at offset ' + i);
        }
        f |= c;
        if (++g >= 4) {
          e[e.length] = f >> 16;
          e[e.length] = (f >> 8) & 0xff;
          e[e.length] = f & 0xff;
          f = 0;
          g = 0;
        } else {
          f <<= 6;
        }
      }
      switch (g) {
        case 1:
          throw new Error(
            'Base64 encoding incomplete: at least 2 bits missing',
          );
        case 2:
          e[e.length] = f >> 10;
          break;
        case 3:
          e[e.length] = f >> 16;
          e[e.length] = (f >> 8) & 0xff;
          break;
      }
      return e;
    },
    re: /-----BEGIN [^-]+-----([A-Za-z0-9+\/=\s]+)-----END [^-]+-----|begin-base64[^\n]+\n([A-Za-z0-9+\/=\s]+)====/,
    unarmor: function (a) {
      var m = O.re.exec(a);
      if (m) {
        if (m[1]) {
          a = m[1];
        } else if (m[2]) {
          a = m[2];
        } else {
          throw new Error('RegExp out of sync');
        }
      }
      return O.decode(a);
    },
  };
  var R = 10000000000000;
  var S = (function () {
    function S(a) {
      this.buf = [+a || 0];
    }
    S.prototype.mulAdd = function (m, c) {
      var b = this.buf;
      var l = b.length;
      var i;
      var t;
      for (i = 0; i < l; ++i) {
        t = b[i] * m + c;
        if (t < R) {
          c = 0;
        } else {
          c = 0 | (t / R);
          t -= c * R;
        }
        b[i] = t;
      }
      if (c > 0) {
        b[i] = c;
      }
    };
    S.prototype.sub = function (c) {
      var b = this.buf;
      var l = b.length;
      var i;
      var t;
      for (i = 0; i < l; ++i) {
        t = b[i] - c;
        if (t < 0) {
          t += R;
          c = 1;
        } else {
          c = 0;
        }
        b[i] = t;
      }
      while (b[b.length - 1] === 0) {
        b.pop();
      }
    };
    S.prototype.toString = function (a) {
      if ((a || 10) != 10) {
        throw new Error('only base 10 is supported');
      }
      var b = this.buf;
      var s = b[b.length - 1].toString();
      for (var i = b.length - 2; i >= 0; --i) {
        s += (R + b[i]).toString().substring(1);
      }
      return s;
    };
    S.prototype.valueOf = function () {
      var b = this.buf;
      var v = 0;
      for (var i = b.length - 1; i >= 0; --i) {
        v = v * R + b[i];
      }
      return v;
    };
    S.prototype.simplify = function () {
      var b = this.buf;
      return b.length == 1 ? b[0] : this;
    };
    return S;
  })();
  var T = '\u2026';
  var U =
    /^(\d\d)(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])(?:([0-5]\d)(?:([0-5]\d)(?:[.,](\d{1,3}))?)?)?(Z|[-+](?:[0]\d|1[0-2])([0-5]\d)?)?$/;
  var V =
    /^(\d\d\d\d)(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])(?:([0-5]\d)(?:([0-5]\d)(?:[.,](\d{1,3}))?)?)?(Z|[-+](?:[0]\d|1[0-2])([0-5]\d)?)?$/;
  function stringCut(a, b) {
    if (a.length > b) {
      a = a.substring(0, b) + T;
    }
    return a;
  }
  var W = (function () {
    function W(a, b) {
      this.hexDigits = '0123456789ABCDEF';
      if (a instanceof W) {
        this.enc = a.enc;
        this.pos = a.pos;
      } else {
        this.enc = a;
        this.pos = b;
      }
    }
    W.prototype.get = function (a) {
      if (a === undefined) {
        a = this.pos++;
      }
      if (a >= this.enc.length) {
        throw new Error(
          'Requesting byte offset ' +
            a +
            ' on a stream of length ' +
            this.enc.length,
        );
      }
      return 'string' === typeof this.enc
        ? this.enc.charCodeAt(a)
        : this.enc[a];
    };
    W.prototype.hexByte = function (b) {
      return (
        this.hexDigits.charAt((b >> 4) & 0xf) + this.hexDigits.charAt(b & 0xf)
      );
    };
    W.prototype.hexDump = function (a, b, c) {
      var s = '';
      for (var i = a; i < b; ++i) {
        s += this.hexByte(this.get(i));
        if (c !== true) {
          switch (i & 0xf) {
            case 0x7:
              s += '  ';
              break;
            case 0xf:
              s += '\n';
              break;
            default:
              s += ' ';
          }
        }
      }
      return s;
    };
    W.prototype.isASCII = function (a, b) {
      for (var i = a; i < b; ++i) {
        var c = this.get(i);
        if (c < 32 || c > 176) {
          return false;
        }
      }
      return true;
    };
    W.prototype.parseStringISO = function (a, b) {
      var s = '';
      for (var i = a; i < b; ++i) {
        s += String.fromCharCode(this.get(i));
      }
      return s;
    };
    W.prototype.parseStringUTF = function (a, b) {
      var s = '';
      for (var i = a; i < b; ) {
        var c = this.get(i++);
        if (c < 128) {
          s += String.fromCharCode(c);
        } else if (c > 191 && c < 224) {
          s += String.fromCharCode(((c & 0x1f) << 6) | (this.get(i++) & 0x3f));
        } else {
          s += String.fromCharCode(
            ((c & 0x0f) << 12) |
              ((this.get(i++) & 0x3f) << 6) |
              (this.get(i++) & 0x3f),
          );
        }
      }
      return s;
    };
    W.prototype.parseStringBMP = function (a, b) {
      var c = '';
      var d;
      var e;
      for (var i = a; i < b; ) {
        d = this.get(i++);
        e = this.get(i++);
        c += String.fromCharCode((d << 8) | e);
      }
      return c;
    };
    W.prototype.parseTime = function (a, b, c) {
      var s = this.parseStringISO(a, b);
      var m = (c ? U : V).exec(s);
      if (!m) {
        return 'Unrecognized time: ' + s;
      }
      if (c) {
        m[1] = +m[1];
        m[1] += +m[1] < 70 ? 2000 : 1900;
      }
      s = m[1] + '-' + m[2] + '-' + m[3] + ' ' + m[4];
      if (m[5]) {
        s += ':' + m[5];
        if (m[6]) {
          s += ':' + m[6];
          if (m[7]) {
            s += '.' + m[7];
          }
        }
      }
      if (m[8]) {
        s += ' UTC';
        if (m[8] != 'Z') {
          s += m[8];
          if (m[9]) {
            s += ':' + m[9];
          }
        }
      }
      return s;
    };
    W.prototype.parseInteger = function (a, b) {
      var v = this.get(a);
      var c = v > 127;
      var d = c ? 255 : 0;
      var e;
      var s = '';
      while (v == d && ++a < b) {
        v = this.get(a);
      }
      e = b - a;
      if (e === 0) {
        return c ? -1 : 0;
      }
      if (e > 4) {
        s = v;
        e <<= 3;
        while (((+s ^ d) & 0x80) == 0) {
          s = +s << 1;
          --e;
        }
        s = '(' + e + ' bit)\n';
      }
      if (c) {
        v = v - 256;
      }
      var n = new S(v);
      for (var i = a + 1; i < b; ++i) {
        n.mulAdd(256, this.get(i));
      }
      return s + n.toString();
    };
    W.prototype.parseBitString = function (a, c, d) {
      var e = this.get(a);
      var f = ((c - a - 1) << 3) - e;
      var g = '(' + f + ' bit)\n';
      var s = '';
      for (var i = a + 1; i < c; ++i) {
        var b = this.get(i);
        var h = i == c - 1 ? e : 0;
        for (var j = 7; j >= h; --j) {
          s += (b >> j) & 1 ? '1' : '0';
        }
        if (s.length > d) {
          return g + stringCut(s, d);
        }
      }
      return g + s;
    };
    W.prototype.parseOctetString = function (a, b, c) {
      if (this.isASCII(a, b)) {
        return stringCut(this.parseStringISO(a, b), c);
      }
      var d = b - a;
      var s = '(' + d + ' byte)\n';
      c /= 2;
      if (d > c) {
        b = a + c;
      }
      for (var i = a; i < b; ++i) {
        s += this.hexByte(this.get(i));
      }
      if (d > c) {
        s += T;
      }
      return s;
    };
    W.prototype.parseOID = function (a, b, c) {
      var s = '';
      var n = new S();
      var d = 0;
      for (var i = a; i < b; ++i) {
        var v = this.get(i);
        n.mulAdd(128, v & 0x7f);
        d += 7;
        if (!(v & 0x80)) {
          if (s === '') {
            n = n.simplify();
            if (n instanceof S) {
              n.sub(80);
              s = '2.' + n.toString();
            } else {
              var m = n < 80 ? (n < 40 ? 0 : 1) : 2;
              s = m + '.' + (n - m * 40);
            }
          } else {
            s += '.' + n.toString();
          }
          if (s.length > c) {
            return stringCut(s, c);
          }
          n = new S();
          d = 0;
        }
      }
      if (d > 0) {
        s += '.incomplete';
      }
      return s;
    };
    return W;
  })();
  var X = (function () {
    function X(a, b, c, d, e) {
      if (!(d instanceof Y)) {
        throw new Error('Invalid tag value.');
      }
      this.stream = a;
      this.header = b;
      this.length = c;
      this.tag = d;
      this.sub = e;
    }
    X.prototype.typeName = function () {
      switch (this.tag.tagClass) {
        case 0:
          switch (this.tag.tagNumber) {
            case 0x00:
              return 'EOC';
            case 0x01:
              return 'BOOLEAN';
            case 0x02:
              return 'INTEGER';
            case 0x03:
              return 'BIT_STRING';
            case 0x04:
              return 'OCTET_STRING';
            case 0x05:
              return 'NULL';
            case 0x06:
              return 'OBJECT_IDENTIFIER';
            case 0x07:
              return 'ObjectDescriptor';
            case 0x08:
              return 'EXTERNAL';
            case 0x09:
              return 'REAL';
            case 0x0a:
              return 'ENUMERATED';
            case 0x0b:
              return 'EMBEDDED_PDV';
            case 0x0c:
              return 'UTF8String';
            case 0x10:
              return 'SEQUENCE';
            case 0x11:
              return 'SET';
            case 0x12:
              return 'NumericString';
            case 0x13:
              return 'PrintableString';
            case 0x14:
              return 'TeletexString';
            case 0x15:
              return 'VideotexString';
            case 0x16:
              return 'IA5String';
            case 0x17:
              return 'UTCTime';
            case 0x18:
              return 'GeneralizedTime';
            case 0x19:
              return 'GraphicString';
            case 0x1a:
              return 'VisibleString';
            case 0x1b:
              return 'GeneralString';
            case 0x1c:
              return 'UniversalString';
            case 0x1e:
              return 'BMPString';
          }
          return 'Universal_' + this.tag.tagNumber.toString();
        case 1:
          return 'Application_' + this.tag.tagNumber.toString();
        case 2:
          return '[' + this.tag.tagNumber.toString() + ']';
        case 3:
          return 'Private_' + this.tag.tagNumber.toString();
      }
    };
    X.prototype.content = function (a) {
      if (this.tag === undefined) {
        return null;
      }
      if (a === undefined) {
        a = Infinity;
      }
      var b = this.posContent();
      var c = Math.abs(this.length);
      if (!this.tag.isUniversal()) {
        if (this.sub !== null) {
          return '(' + this.sub.length + ' elem)';
        }
        return this.stream.parseOctetString(b, b + c, a);
      }
      switch (this.tag.tagNumber) {
        case 0x01:
          return this.stream.get(b) === 0 ? 'false' : 'true';
        case 0x02:
          return this.stream.parseInteger(b, b + c);
        case 0x03:
          return this.sub
            ? '(' + this.sub.length + ' elem)'
            : this.stream.parseBitString(b, b + c, a);
        case 0x04:
          return this.sub
            ? '(' + this.sub.length + ' elem)'
            : this.stream.parseOctetString(b, b + c, a);
        case 0x06:
          return this.stream.parseOID(b, b + c, a);
        case 0x10:
        case 0x11:
          if (this.sub !== null) {
            return '(' + this.sub.length + ' elem)';
          } else {
            return '(no elem)';
          }
        case 0x0c:
          return stringCut(this.stream.parseStringUTF(b, b + c), a);
        case 0x12:
        case 0x13:
        case 0x14:
        case 0x15:
        case 0x16:
        case 0x1a:
          return stringCut(this.stream.parseStringISO(b, b + c), a);
        case 0x1e:
          return stringCut(this.stream.parseStringBMP(b, b + c), a);
        case 0x17:
        case 0x18:
          return this.stream.parseTime(b, b + c, this.tag.tagNumber == 0x17);
      }
      return null;
    };
    X.prototype.toString = function () {
      return (
        this.typeName() +
        '@' +
        this.stream.pos +
        '[header:' +
        this.header +
        ',length:' +
        this.length +
        ',sub:' +
        (this.sub === null ? 'null' : this.sub.length) +
        ']'
      );
    };
    X.prototype.toPrettyString = function (a) {
      if (a === undefined) {
        a = '';
      }
      var s = a + this.typeName() + ' @' + this.stream.pos;
      if (this.length >= 0) {
        s += '+';
      }
      s += this.length;
      if (this.tag.tagConstructed) {
        s += ' (constructed)';
      } else if (
        this.tag.isUniversal() &&
        (this.tag.tagNumber == 0x03 || this.tag.tagNumber == 0x04) &&
        this.sub !== null
      ) {
        s += ' (encapsulates)';
      }
      s += '\n';
      if (this.sub !== null) {
        a += '  ';
        for (var i = 0, R = this.sub.length; i < R; ++i) {
          s += this.sub[i].toPrettyString(a);
        }
      }
      return s;
    };
    X.prototype.posStart = function () {
      return this.stream.pos;
    };
    X.prototype.posContent = function () {
      return this.stream.pos + this.header;
    };
    X.prototype.posEnd = function () {
      return this.stream.pos + this.header + Math.abs(this.length);
    };
    X.prototype.toHexString = function () {
      return this.stream.hexDump(this.posStart(), this.posEnd(), true);
    };
    X.decodeLength = function (a) {
      var b = a.get();
      var c = b & 0x7f;
      if (c == b) {
        return c;
      }
      if (c > 6) {
        throw new Error(
          'Length over 48 bits not supported at position ' + (a.pos - 1),
        );
      }
      if (c === 0) {
        return null;
      }
      b = 0;
      for (var i = 0; i < c; ++i) {
        b = b * 256 + a.get();
      }
      return b;
    };
    X.prototype.getHexStringValue = function () {
      var a = this.toHexString();
      var b = this.header * 2;
      var c = this.length * 2;
      return a.substr(b, c);
    };
    X.decode = function (c) {
      var d;
      if (!(c instanceof W)) {
        d = new W(c, 0);
      } else {
        d = c;
      }
      var f = new W(d);
      var g = new Y(d);
      var h = X.decodeLength(d);
      var j = d.pos;
      var k = j - f.pos;
      var l = null;
      var m = function () {
        var a = [];
        if (h !== null) {
          var b = j + h;
          while (d.pos < b) {
            a[a.length] = X.decode(d);
          }
          if (d.pos != b) {
            throw new Error(
              'Content size is not correct for container starting at offset ' +
                j,
            );
          }
        } else {
          try {
            for (;;) {
              var s = X.decode(d);
              if (s.tag.isEOC()) {
                break;
              }
              a[a.length] = s;
            }
            h = j - d.pos;
          } catch (e) {
            throw new Error(
              'Exception while decoding undefined length content: ' + e,
            );
          }
        }
        return a;
      };
      if (g.tagConstructed) {
        l = m();
      } else if (
        g.isUniversal() &&
        (g.tagNumber == 0x03 || g.tagNumber == 0x04)
      ) {
        try {
          if (g.tagNumber == 0x03) {
            if (d.get() != 0) {
              throw new Error(
                'BIT STRINGs with unused bits cannot encapsulate.',
              );
            }
          }
          l = m();
          for (var i = 0; i < l.length; ++i) {
            if (l[i].tag.isEOC()) {
              throw new Error('EOC is not supposed to be actual content.');
            }
          }
        } catch (e) {
          l = null;
        }
      }
      if (l === null) {
        if (h === null) {
          throw new Error(
            "We can't skip over an invalid tag with undefined length at offset " +
              j,
          );
        }
        d.pos = j + Math.abs(h);
      }
      return new X(f, k, h, g, l);
    };
    return X;
  })();
  var Y = (function () {
    function Y(a) {
      var b = a.get();
      this.tagClass = b >> 6;
      this.tagConstructed = (b & 0x20) !== 0;
      this.tagNumber = b & 0x1f;
      if (this.tagNumber == 0x1f) {
        var n = new S();
        do {
          b = a.get();
          n.mulAdd(128, b & 0x7f);
        } while (b & 0x80);
        this.tagNumber = n.simplify();
      }
    }
    Y.prototype.isUniversal = function () {
      return this.tagClass === 0x00;
    };
    Y.prototype.isEOC = function () {
      return this.tagClass === 0x00 && this.tagNumber === 0x00;
    };
    return Y;
  })();
  var Z;
  var ba = 0xdeadbeefcafe;
  var bb = (ba & 0xffffff) == 0xefcafe;
  var bc = [
    2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71,
    73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151,
    157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233,
    239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317,
    331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419,
    421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503,
    509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607,
    613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691, 701,
    709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797, 809, 811,
    821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911,
    919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997,
  ];
  var bd = (1 << 26) / bc[bc.length - 1];
  var be = (function () {
    function be(a, b, c) {
      if (a != null) {
        if ('number' == typeof a) {
          this.fromNumber(a, b, c);
        } else if (b == null && 'string' != typeof a) {
          this.fromString(a, 256);
        } else {
          this.fromString(a, b);
        }
      }
    }
    be.prototype.toString = function (b) {
      if (this.s < 0) {
        return '-' + this.negate().toString(b);
      }
      var k;
      if (b == 16) {
        k = 4;
      } else if (b == 8) {
        k = 3;
      } else if (b == 2) {
        k = 1;
      } else if (b == 32) {
        k = 5;
      } else if (b == 4) {
        k = 2;
      } else {
        return this.toRadix(b);
      }
      var a = (1 << k) - 1;
      var d;
      var m = false;
      var r = '';
      var i = this.t;
      var p = this.DB - ((i * this.DB) % k);
      if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
          m = true;
          r = int2char(d);
        }
        while (i >= 0) {
          if (p < k) {
            d = (this[i] & ((1 << p) - 1)) << (k - p);
            d |= this[--i] >> (p += this.DB - k);
          } else {
            d = (this[i] >> (p -= k)) & a;
            if (p <= 0) {
              p += this.DB;
              --i;
            }
          }
          if (d > 0) {
            m = true;
          }
          if (m) {
            r += int2char(d);
          }
        }
      }
      return m ? r : '0';
    };
    be.prototype.negate = function () {
      var r = nbi();
      be.ZERO.subTo(this, r);
      return r;
    };
    be.prototype.abs = function () {
      return this.s < 0 ? this.negate() : this;
    };
    be.prototype.compareTo = function (a) {
      var r = this.s - a.s;
      if (r != 0) {
        return r;
      }
      var i = this.t;
      r = i - a.t;
      if (r != 0) {
        return this.s < 0 ? -r : r;
      }
      while (--i >= 0) {
        if ((r = this[i] - a[i]) != 0) {
          return r;
        }
      }
      return 0;
    };
    be.prototype.bitLength = function () {
      if (this.t <= 0) {
        return 0;
      }
      return (
        this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ (this.s & this.DM))
      );
    };
    be.prototype.mod = function (a) {
      var r = nbi();
      this.abs().divRemTo(a, null, r);
      if (this.s < 0 && r.compareTo(be.ZERO) > 0) {
        a.subTo(r, r);
      }
      return r;
    };
    be.prototype.modPowInt = function (e, m) {
      var z;
      if (e < 256 || m.isEven()) {
        z = new bg(m);
      } else {
        z = new bh(m);
      }
      return this.exp(e, z);
    };
    be.prototype.clone = function () {
      var r = nbi();
      this.copyTo(r);
      return r;
    };
    be.prototype.intValue = function () {
      if (this.s < 0) {
        if (this.t == 1) {
          return this[0] - this.DV;
        } else if (this.t == 0) {
          return -1;
        }
      } else if (this.t == 1) {
        return this[0];
      } else if (this.t == 0) {
        return 0;
      }
      return ((this[1] & ((1 << (32 - this.DB)) - 1)) << this.DB) | this[0];
    };
    be.prototype.byteValue = function () {
      return this.t == 0 ? this.s : (this[0] << 24) >> 24;
    };
    be.prototype.shortValue = function () {
      return this.t == 0 ? this.s : (this[0] << 16) >> 16;
    };
    be.prototype.signum = function () {
      if (this.s < 0) {
        return -1;
      } else if (this.t <= 0 || (this.t == 1 && this[0] <= 0)) {
        return 0;
      } else {
        return 1;
      }
    };
    be.prototype.toByteArray = function () {
      var i = this.t;
      var r = [];
      r[0] = this.s;
      var p = this.DB - ((i * this.DB) % 8);
      var d;
      var k = 0;
      if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) != (this.s & this.DM) >> p) {
          r[k++] = d | (this.s << (this.DB - p));
        }
        while (i >= 0) {
          if (p < 8) {
            d = (this[i] & ((1 << p) - 1)) << (8 - p);
            d |= this[--i] >> (p += this.DB - 8);
          } else {
            d = (this[i] >> (p -= 8)) & 0xff;
            if (p <= 0) {
              p += this.DB;
              --i;
            }
          }
          if ((d & 0x80) != 0) {
            d |= -256;
          }
          if (k == 0 && (this.s & 0x80) != (d & 0x80)) {
            ++k;
          }
          if (k > 0 || d != this.s) {
            r[k++] = d;
          }
        }
      }
      return r;
    };
    be.prototype.equals = function (a) {
      return this.compareTo(a) == 0;
    };
    be.prototype.min = function (a) {
      return this.compareTo(a) < 0 ? this : a;
    };
    be.prototype.max = function (a) {
      return this.compareTo(a) > 0 ? this : a;
    };
    be.prototype.and = function (a) {
      var r = nbi();
      this.bitwiseTo(a, op_and, r);
      return r;
    };
    be.prototype.or = function (a) {
      var r = nbi();
      this.bitwiseTo(a, op_or, r);
      return r;
    };
    be.prototype.xor = function (a) {
      var r = nbi();
      this.bitwiseTo(a, op_xor, r);
      return r;
    };
    be.prototype.andNot = function (a) {
      var r = nbi();
      this.bitwiseTo(a, op_andnot, r);
      return r;
    };
    be.prototype.not = function () {
      var r = nbi();
      for (var i = 0; i < this.t; ++i) {
        r[i] = this.DM & ~this[i];
      }
      r.t = this.t;
      r.s = ~this.s;
      return r;
    };
    be.prototype.shiftLeft = function (n) {
      var r = nbi();
      if (n < 0) {
        this.rShiftTo(-n, r);
      } else {
        this.lShiftTo(n, r);
      }
      return r;
    };
    be.prototype.shiftRight = function (n) {
      var r = nbi();
      if (n < 0) {
        this.lShiftTo(-n, r);
      } else {
        this.rShiftTo(n, r);
      }
      return r;
    };
    be.prototype.getLowestSetBit = function () {
      for (var i = 0; i < this.t; ++i) {
        if (this[i] != 0) {
          return i * this.DB + lbit(this[i]);
        }
      }
      if (this.s < 0) {
        return this.t * this.DB;
      }
      return -1;
    };
    be.prototype.bitCount = function () {
      var r = 0;
      var x = this.s & this.DM;
      for (var i = 0; i < this.t; ++i) {
        r += cbit(this[i] ^ x);
      }
      return r;
    };
    be.prototype.testBit = function (n) {
      var j = Math.floor(n / this.DB);
      if (j >= this.t) {
        return this.s != 0;
      }
      return (this[j] & (1 << n % this.DB)) != 0;
    };
    be.prototype.setBit = function (n) {
      return this.changeBit(n, op_or);
    };
    be.prototype.clearBit = function (n) {
      return this.changeBit(n, op_andnot);
    };
    be.prototype.flipBit = function (n) {
      return this.changeBit(n, op_xor);
    };
    be.prototype.add = function (a) {
      var r = nbi();
      this.addTo(a, r);
      return r;
    };
    be.prototype.subtract = function (a) {
      var r = nbi();
      this.subTo(a, r);
      return r;
    };
    be.prototype.multiply = function (a) {
      var r = nbi();
      this.multiplyTo(a, r);
      return r;
    };
    be.prototype.divide = function (a) {
      var r = nbi();
      this.divRemTo(a, r, null);
      return r;
    };
    be.prototype.remainder = function (a) {
      var r = nbi();
      this.divRemTo(a, null, r);
      return r;
    };
    be.prototype.divideAndRemainder = function (a) {
      var q = nbi();
      var r = nbi();
      this.divRemTo(a, q, r);
      return [q, r];
    };
    be.prototype.modPow = function (e, m) {
      var i = e.bitLength();
      var k;
      var r = nbv(1);
      var z;
      if (i <= 0) {
        return r;
      } else if (i < 18) {
        k = 1;
      } else if (i < 48) {
        k = 3;
      } else if (i < 144) {
        k = 4;
      } else if (i < 768) {
        k = 5;
      } else {
        k = 6;
      }
      if (i < 8) {
        z = new bg(m);
      } else if (m.isEven()) {
        z = new bi(m);
      } else {
        z = new bh(m);
      }
      var g = [];
      var n = 3;
      var a = k - 1;
      var b = (1 << k) - 1;
      g[1] = z.convert(this);
      if (k > 1) {
        var c = nbi();
        z.sqrTo(g[1], c);
        while (n <= b) {
          g[n] = nbi();
          z.mulTo(c, g[n - 2], g[n]);
          n += 2;
        }
      }
      var j = e.t - 1;
      var w;
      var d = true;
      var f = nbi();
      var t;
      i = nbits(e[j]) - 1;
      while (j >= 0) {
        if (i >= a) {
          w = (e[j] >> (i - a)) & b;
        } else {
          w = (e[j] & ((1 << (i + 1)) - 1)) << (a - i);
          if (j > 0) {
            w |= e[j - 1] >> (this.DB + i - a);
          }
        }
        n = k;
        while ((w & 1) == 0) {
          w >>= 1;
          --n;
        }
        if ((i -= n) < 0) {
          i += this.DB;
          --j;
        }
        if (d) {
          g[w].copyTo(r);
          d = false;
        } else {
          while (n > 1) {
            z.sqrTo(r, f);
            z.sqrTo(f, r);
            n -= 2;
          }
          if (n > 0) {
            z.sqrTo(r, f);
          } else {
            t = r;
            r = f;
            f = t;
          }
          z.mulTo(f, g[w], r);
        }
        while (j >= 0 && (e[j] & (1 << i)) == 0) {
          z.sqrTo(r, f);
          t = r;
          r = f;
          f = t;
          if (--i < 0) {
            i = this.DB - 1;
            --j;
          }
        }
      }
      return z.revert(r);
    };
    be.prototype.modInverse = function (m) {
      var e = m.isEven();
      if ((this.isEven() && e) || m.signum() == 0) {
        return be.ZERO;
      }
      var u = m.clone();
      var v = this.clone();
      var a = nbv(1);
      var b = nbv(0);
      var c = nbv(0);
      var d = nbv(1);
      while (u.signum() != 0) {
        while (u.isEven()) {
          u.rShiftTo(1, u);
          if (e) {
            if (!a.isEven() || !b.isEven()) {
              a.addTo(this, a);
              b.subTo(m, b);
            }
            a.rShiftTo(1, a);
          } else if (!b.isEven()) {
            b.subTo(m, b);
          }
          b.rShiftTo(1, b);
        }
        while (v.isEven()) {
          v.rShiftTo(1, v);
          if (e) {
            if (!c.isEven() || !d.isEven()) {
              c.addTo(this, c);
              d.subTo(m, d);
            }
            c.rShiftTo(1, c);
          } else if (!d.isEven()) {
            d.subTo(m, d);
          }
          d.rShiftTo(1, d);
        }
        if (u.compareTo(v) >= 0) {
          u.subTo(v, u);
          if (e) {
            a.subTo(c, a);
          }
          b.subTo(d, b);
        } else {
          v.subTo(u, v);
          if (e) {
            c.subTo(a, c);
          }
          d.subTo(b, d);
        }
      }
      if (v.compareTo(be.ONE) != 0) {
        return be.ZERO;
      }
      if (d.compareTo(m) >= 0) {
        return d.subtract(m);
      }
      if (d.signum() < 0) {
        d.addTo(m, d);
      } else {
        return d;
      }
      if (d.signum() < 0) {
        return d.add(m);
      } else {
        return d;
      }
    };
    be.prototype.pow = function (e) {
      return this.exp(e, new bf());
    };
    be.prototype.gcd = function (a) {
      var x = this.s < 0 ? this.negate() : this.clone();
      var y = a.s < 0 ? a.negate() : a.clone();
      if (x.compareTo(y) < 0) {
        var t = x;
        x = y;
        y = t;
      }
      var i = x.getLowestSetBit();
      var g = y.getLowestSetBit();
      if (g < 0) {
        return x;
      }
      if (i < g) {
        g = i;
      }
      if (g > 0) {
        x.rShiftTo(g, x);
        y.rShiftTo(g, y);
      }
      while (x.signum() > 0) {
        if ((i = x.getLowestSetBit()) > 0) {
          x.rShiftTo(i, x);
        }
        if ((i = y.getLowestSetBit()) > 0) {
          y.rShiftTo(i, y);
        }
        if (x.compareTo(y) >= 0) {
          x.subTo(y, x);
          x.rShiftTo(1, x);
        } else {
          y.subTo(x, y);
          y.rShiftTo(1, y);
        }
      }
      if (g > 0) {
        y.lShiftTo(g, y);
      }
      return y;
    };
    be.prototype.isProbablePrime = function (t) {
      var i;
      var x = this.abs();
      if (x.t == 1 && x[0] <= bc[bc.length - 1]) {
        for (i = 0; i < bc.length; ++i) {
          if (x[0] == bc[i]) {
            return true;
          }
        }
        return false;
      }
      if (x.isEven()) {
        return false;
      }
      i = 1;
      while (i < bc.length) {
        var m = bc[i];
        var j = i + 1;
        while (j < bc.length && m < bd) {
          m *= bc[j++];
        }
        m = x.modInt(m);
        while (i < j) {
          if (m % bc[i++] == 0) {
            return false;
          }
        }
      }
      return x.millerRabin(t);
    };
    be.prototype.copyTo = function (r) {
      for (var i = this.t - 1; i >= 0; --i) {
        r[i] = this[i];
      }
      r.t = this.t;
      r.s = this.s;
    };
    be.prototype.fromInt = function (x) {
      this.t = 1;
      this.s = x < 0 ? -1 : 0;
      if (x > 0) {
        this[0] = x;
      } else if (x < -1) {
        this[0] = x + this.DV;
      } else {
        this.t = 0;
      }
    };
    be.prototype.fromString = function (s, b) {
      var k;
      if (b == 16) {
        k = 4;
      } else if (b == 8) {
        k = 3;
      } else if (b == 256) {
        k = 8;
      } else if (b == 2) {
        k = 1;
      } else if (b == 32) {
        k = 5;
      } else if (b == 4) {
        k = 2;
      } else {
        this.fromRadix(s, b);
        return;
      }
      this.t = 0;
      this.s = 0;
      var i = s.length;
      var a = false;
      var c = 0;
      while (--i >= 0) {
        var x = k == 8 ? +s[i] & 0xff : intAt(s, i);
        if (x < 0) {
          if (s.charAt(i) == '-') {
            a = true;
          }
          continue;
        }
        a = false;
        if (c == 0) {
          this[this.t++] = x;
        } else if (c + k > this.DB) {
          this[this.t - 1] |= (x & ((1 << (this.DB - c)) - 1)) << c;
          this[this.t++] = x >> (this.DB - c);
        } else {
          this[this.t - 1] |= x << c;
        }
        c += k;
        if (c >= this.DB) {
          c -= this.DB;
        }
      }
      if (k == 8 && (+s[0] & 0x80) != 0) {
        this.s = -1;
        if (c > 0) {
          this[this.t - 1] |= ((1 << (this.DB - c)) - 1) << c;
        }
      }
      this.clamp();
      if (a) {
        be.ZERO.subTo(this, this);
      }
    };
    be.prototype.clamp = function () {
      var c = this.s & this.DM;
      while (this.t > 0 && this[this.t - 1] == c) {
        --this.t;
      }
    };
    be.prototype.dlShiftTo = function (n, r) {
      var i;
      for (i = this.t - 1; i >= 0; --i) {
        r[i + n] = this[i];
      }
      for (i = n - 1; i >= 0; --i) {
        r[i] = 0;
      }
      r.t = this.t + n;
      r.s = this.s;
    };
    be.prototype.drShiftTo = function (n, r) {
      for (var i = n; i < this.t; ++i) {
        r[i - n] = this[i];
      }
      r.t = Math.max(this.t - n, 0);
      r.s = this.s;
    };
    be.prototype.lShiftTo = function (n, r) {
      var a = n % this.DB;
      var b = this.DB - a;
      var d = (1 << b) - 1;
      var e = Math.floor(n / this.DB);
      var c = (this.s << a) & this.DM;
      for (var i = this.t - 1; i >= 0; --i) {
        r[i + e + 1] = (this[i] >> b) | c;
        c = (this[i] & d) << a;
      }
      for (var i = e - 1; i >= 0; --i) {
        r[i] = 0;
      }
      r[e] = c;
      r.t = this.t + e + 1;
      r.s = this.s;
      r.clamp();
    };
    be.prototype.rShiftTo = function (n, r) {
      r.s = this.s;
      var a = Math.floor(n / this.DB);
      if (a >= this.t) {
        r.t = 0;
        return;
      }
      var b = n % this.DB;
      var c = this.DB - b;
      var d = (1 << b) - 1;
      r[0] = this[a] >> b;
      for (var i = a + 1; i < this.t; ++i) {
        r[i - a - 1] |= (this[i] & d) << c;
        r[i - a] = this[i] >> b;
      }
      if (b > 0) {
        r[this.t - a - 1] |= (this.s & d) << c;
      }
      r.t = this.t - a;
      r.clamp();
    };
    be.prototype.subTo = function (a, r) {
      var i = 0;
      var c = 0;
      var m = Math.min(a.t, this.t);
      while (i < m) {
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
      }
      if (a.t < this.t) {
        c -= a.s;
        while (i < this.t) {
          c += this[i];
          r[i++] = c & this.DM;
          c >>= this.DB;
        }
        c += this.s;
      } else {
        c += this.s;
        while (i < a.t) {
          c -= a[i];
          r[i++] = c & this.DM;
          c >>= this.DB;
        }
        c -= a.s;
      }
      r.s = c < 0 ? -1 : 0;
      if (c < -1) {
        r[i++] = this.DV + c;
      } else if (c > 0) {
        r[i++] = c;
      }
      r.t = i;
      r.clamp();
    };
    be.prototype.multiplyTo = function (a, r) {
      var x = this.abs();
      var y = a.abs();
      var i = x.t;
      r.t = i + y.t;
      while (--i >= 0) {
        r[i] = 0;
      }
      for (i = 0; i < y.t; ++i) {
        r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
      }
      r.s = 0;
      r.clamp();
      if (this.s != a.s) {
        be.ZERO.subTo(r, r);
      }
    };
    be.prototype.squareTo = function (r) {
      var x = this.abs();
      var i = (r.t = 2 * x.t);
      while (--i >= 0) {
        r[i] = 0;
      }
      for (i = 0; i < x.t - 1; ++i) {
        var c = x.am(i, x[i], r, 2 * i, 0, 1);
        if (
          (r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >=
          x.DV
        ) {
          r[i + x.t] -= x.DV;
          r[i + x.t + 1] = 1;
        }
      }
      if (r.t > 0) {
        r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
      }
      r.s = 0;
      r.clamp();
    };
    be.prototype.divRemTo = function (m, q, r) {
      var a = m.abs();
      if (a.t <= 0) {
        return;
      }
      var b = this.abs();
      if (b.t < a.t) {
        if (q != null) {
          q.fromInt(0);
        }
        if (r != null) {
          this.copyTo(r);
        }
        return;
      }
      if (r == null) {
        r = nbi();
      }
      var y = nbi();
      var c = this.s;
      var d = m.s;
      var f = this.DB - nbits(a[a.t - 1]);
      if (f > 0) {
        a.lShiftTo(f, y);
        b.lShiftTo(f, r);
      } else {
        a.copyTo(y);
        b.copyTo(r);
      }
      var g = y.t;
      var h = y[g - 1];
      if (h == 0) {
        return;
      }
      var k = h * (1 << this.F1) + (g > 1 ? y[g - 2] >> this.F2 : 0);
      var l = this.FV / k;
      var n = (1 << this.F1) / k;
      var e = 1 << this.F2;
      var i = r.t;
      var j = i - g;
      var t = q == null ? nbi() : q;
      y.dlShiftTo(j, t);
      if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
      }
      be.ONE.dlShiftTo(g, t);
      t.subTo(y, y);
      while (y.t < g) {
        y[y.t++] = 0;
      }
      while (--j >= 0) {
        var o =
          r[--i] == h ? this.DM : Math.floor(r[i] * l + (r[i - 1] + e) * n);
        if ((r[i] += y.am(0, o, r, j, 0, g)) < o) {
          y.dlShiftTo(j, t);
          r.subTo(t, r);
          while (r[i] < --o) {
            r.subTo(t, r);
          }
        }
      }
      if (q != null) {
        r.drShiftTo(g, q);
        if (c != d) {
          be.ZERO.subTo(q, q);
        }
      }
      r.t = g;
      r.clamp();
      if (f > 0) {
        r.rShiftTo(f, r);
      }
      if (c < 0) {
        be.ZERO.subTo(r, r);
      }
    };
    be.prototype.invDigit = function () {
      if (this.t < 1) {
        return 0;
      }
      var x = this[0];
      if ((x & 1) == 0) {
        return 0;
      }
      var y = x & 3;
      y = (y * (2 - (x & 0xf) * y)) & 0xf;
      y = (y * (2 - (x & 0xff) * y)) & 0xff;
      y = (y * (2 - (((x & 0xffff) * y) & 0xffff))) & 0xffff;
      y = (y * (2 - ((x * y) % this.DV))) % this.DV;
      return y > 0 ? this.DV - y : -y;
    };
    be.prototype.isEven = function () {
      return (this.t > 0 ? this[0] & 1 : this.s) == 0;
    };
    be.prototype.exp = function (e, z) {
      if (e > 0xffffffff || e < 1) {
        return be.ONE;
      }
      var r = nbi();
      var a = nbi();
      var g = z.convert(this);
      var i = nbits(e) - 1;
      g.copyTo(r);
      while (--i >= 0) {
        z.sqrTo(r, a);
        if ((e & (1 << i)) > 0) {
          z.mulTo(a, g, r);
        } else {
          var t = r;
          r = a;
          a = t;
        }
      }
      return z.revert(r);
    };
    be.prototype.chunkSize = function (r) {
      return Math.floor((Math.LN2 * this.DB) / Math.log(r));
    };
    be.prototype.toRadix = function (b) {
      if (b == null) {
        b = 10;
      }
      if (this.signum() == 0 || b < 2 || b > 36) {
        return '0';
      }
      var c = this.chunkSize(b);
      var a = Math.pow(b, c);
      var d = nbv(a);
      var y = nbi();
      var z = nbi();
      var r = '';
      this.divRemTo(d, y, z);
      while (y.signum() > 0) {
        r = (a + z.intValue()).toString(b).substr(1) + r;
        y.divRemTo(d, y, z);
      }
      return z.intValue().toString(b) + r;
    };
    be.prototype.fromRadix = function (s, b) {
      this.fromInt(0);
      if (b == null) {
        b = 10;
      }
      var a = this.chunkSize(b);
      var d = Math.pow(b, a);
      var c = false;
      var j = 0;
      var w = 0;
      for (var i = 0; i < s.length; ++i) {
        var x = intAt(s, i);
        if (x < 0) {
          if (s.charAt(i) == '-' && this.signum() == 0) {
            c = true;
          }
          continue;
        }
        w = b * w + x;
        if (++j >= a) {
          this.dMultiply(d);
          this.dAddOffset(w, 0);
          j = 0;
          w = 0;
        }
      }
      if (j > 0) {
        this.dMultiply(Math.pow(b, j));
        this.dAddOffset(w, 0);
      }
      if (c) {
        be.ZERO.subTo(this, this);
      }
    };
    be.prototype.fromNumber = function (a, b, c) {
      if ('number' == typeof b) {
        if (a < 2) {
          this.fromInt(1);
        } else {
          this.fromNumber(a, c);
          if (!this.testBit(a - 1)) {
            this.bitwiseTo(be.ONE.shiftLeft(a - 1), op_or, this);
          }
          if (this.isEven()) {
            this.dAddOffset(1, 0);
          }
          while (!this.isProbablePrime(b)) {
            this.dAddOffset(2, 0);
            if (this.bitLength() > a) {
              this.subTo(be.ONE.shiftLeft(a - 1), this);
            }
          }
        }
      } else {
        var x = [];
        var t = a & 7;
        x.length = (a >> 3) + 1;
        b.nextBytes(x);
        if (t > 0) {
          x[0] &= (1 << t) - 1;
        } else {
          x[0] = 0;
        }
        this.fromString(x, 256);
      }
    };
    be.prototype.bitwiseTo = function (a, b, r) {
      var i;
      var f;
      var m = Math.min(a.t, this.t);
      for (i = 0; i < m; ++i) {
        r[i] = b(this[i], a[i]);
      }
      if (a.t < this.t) {
        f = a.s & this.DM;
        for (i = m; i < this.t; ++i) {
          r[i] = b(this[i], f);
        }
        r.t = this.t;
      } else {
        f = this.s & this.DM;
        for (i = m; i < a.t; ++i) {
          r[i] = b(f, a[i]);
        }
        r.t = a.t;
      }
      r.s = b(this.s, a.s);
      r.clamp();
    };
    be.prototype.changeBit = function (n, a) {
      var r = be.ONE.shiftLeft(n);
      this.bitwiseTo(r, a, r);
      return r;
    };
    be.prototype.addTo = function (a, r) {
      var i = 0;
      var c = 0;
      var m = Math.min(a.t, this.t);
      while (i < m) {
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
      }
      if (a.t < this.t) {
        c += a.s;
        while (i < this.t) {
          c += this[i];
          r[i++] = c & this.DM;
          c >>= this.DB;
        }
        c += this.s;
      } else {
        c += this.s;
        while (i < a.t) {
          c += a[i];
          r[i++] = c & this.DM;
          c >>= this.DB;
        }
        c += a.s;
      }
      r.s = c < 0 ? -1 : 0;
      if (c > 0) {
        r[i++] = c;
      } else if (c < -1) {
        r[i++] = this.DV + c;
      }
      r.t = i;
      r.clamp();
    };
    be.prototype.dMultiply = function (n) {
      this[this.t] = this.am(0, n - 1, this, 0, 0, this.t);
      ++this.t;
      this.clamp();
    };
    be.prototype.dAddOffset = function (n, w) {
      if (n == 0) {
        return;
      }
      while (this.t <= w) {
        this[this.t++] = 0;
      }
      this[w] += n;
      while (this[w] >= this.DV) {
        this[w] -= this.DV;
        if (++w >= this.t) {
          this[this.t++] = 0;
        }
        ++this[w];
      }
    };
    be.prototype.multiplyLowerTo = function (a, n, r) {
      var i = Math.min(this.t + a.t, n);
      r.s = 0;
      r.t = i;
      while (i > 0) {
        r[--i] = 0;
      }
      for (var j = r.t - this.t; i < j; ++i) {
        r[i + this.t] = this.am(0, a[i], r, i, 0, this.t);
      }
      for (var j = Math.min(a.t, n); i < j; ++i) {
        this.am(0, a[i], r, i, 0, n - i);
      }
      r.clamp();
    };
    be.prototype.multiplyUpperTo = function (a, n, r) {
      --n;
      var i = (r.t = this.t + a.t - n);
      r.s = 0;
      while (--i >= 0) {
        r[i] = 0;
      }
      for (i = Math.max(n - this.t, 0); i < a.t; ++i) {
        r[this.t + i - n] = this.am(n - i, a[i], r, 0, 0, this.t + i - n);
      }
      r.clamp();
      r.drShiftTo(1, r);
    };
    be.prototype.modInt = function (n) {
      if (n <= 0) {
        return 0;
      }
      var d = this.DV % n;
      var r = this.s < 0 ? n - 1 : 0;
      if (this.t > 0) {
        if (d == 0) {
          r = this[0] % n;
        } else {
          for (var i = this.t - 1; i >= 0; --i) {
            r = (d * r + this[i]) % n;
          }
        }
      }
      return r;
    };
    be.prototype.millerRabin = function (t) {
      var b = this.subtract(be.ONE);
      var k = b.getLowestSetBit();
      if (k <= 0) {
        return false;
      }
      var r = b.shiftRight(k);
      t = (t + 1) >> 1;
      if (t > bc.length) {
        t = bc.length;
      }
      var a = nbi();
      for (var i = 0; i < t; ++i) {
        a.fromInt(bc[Math.floor(Math.random() * bc.length)]);
        var y = a.modPow(r, this);
        if (y.compareTo(be.ONE) != 0 && y.compareTo(b) != 0) {
          var j = 1;
          while (j++ < k && y.compareTo(b) != 0) {
            y = y.modPowInt(2, this);
            if (y.compareTo(be.ONE) == 0) {
              return false;
            }
          }
          if (y.compareTo(b) != 0) {
            return false;
          }
        }
      }
      return true;
    };
    be.prototype.square = function () {
      var r = nbi();
      this.squareTo(r);
      return r;
    };
    be.prototype.gcda = function (a, b) {
      var x = this.s < 0 ? this.negate() : this.clone();
      var y = a.s < 0 ? a.negate() : a.clone();
      if (x.compareTo(y) < 0) {
        var t = x;
        x = y;
        y = t;
      }
      var i = x.getLowestSetBit();
      var g = y.getLowestSetBit();
      if (g < 0) {
        b(x);
        return;
      }
      if (i < g) {
        g = i;
      }
      if (g > 0) {
        x.rShiftTo(g, x);
        y.rShiftTo(g, y);
      }
      var c = function () {
        if ((i = x.getLowestSetBit()) > 0) {
          x.rShiftTo(i, x);
        }
        if ((i = y.getLowestSetBit()) > 0) {
          y.rShiftTo(i, y);
        }
        if (x.compareTo(y) >= 0) {
          x.subTo(y, x);
          x.rShiftTo(1, x);
        } else {
          y.subTo(x, y);
          y.rShiftTo(1, y);
        }
        if (!(x.signum() > 0)) {
          if (g > 0) {
            y.lShiftTo(g, y);
          }
          setTimeout(function () {
            b(y);
          }, 0);
        } else {
          setTimeout(c, 0);
        }
      };
      setTimeout(c, 10);
    };
    be.prototype.fromNumberAsync = function (a, b, c, d) {
      if ('number' == typeof b) {
        if (a < 2) {
          this.fromInt(1);
        } else {
          this.fromNumber(a, c);
          if (!this.testBit(a - 1)) {
            this.bitwiseTo(be.ONE.shiftLeft(a - 1), op_or, this);
          }
          if (this.isEven()) {
            this.dAddOffset(1, 0);
          }
          var e = this;
          var f = function () {
            e.dAddOffset(2, 0);
            if (e.bitLength() > a) {
              e.subTo(be.ONE.shiftLeft(a - 1), e);
            }
            if (e.isProbablePrime(b)) {
              setTimeout(function () {
                d();
              }, 0);
            } else {
              setTimeout(f, 0);
            }
          };
          setTimeout(f, 0);
        }
      } else {
        var x = [];
        var t = a & 7;
        x.length = (a >> 3) + 1;
        b.nextBytes(x);
        if (t > 0) {
          x[0] &= (1 << t) - 1;
        } else {
          x[0] = 0;
        }
        this.fromString(x, 256);
      }
    };
    return be;
  })();
  var bf = (function () {
    function bf() {}
    bf.prototype.convert = function (x) {
      return x;
    };
    bf.prototype.revert = function (x) {
      return x;
    };
    bf.prototype.mulTo = function (x, y, r) {
      x.multiplyTo(y, r);
    };
    bf.prototype.sqrTo = function (x, r) {
      x.squareTo(r);
    };
    return bf;
  })();
  var bg = (function () {
    function bg(m) {
      this.m = m;
    }
    bg.prototype.convert = function (x) {
      if (x.s < 0 || x.compareTo(this.m) >= 0) {
        return x.mod(this.m);
      } else {
        return x;
      }
    };
    bg.prototype.revert = function (x) {
      return x;
    };
    bg.prototype.reduce = function (x) {
      x.divRemTo(this.m, null, x);
    };
    bg.prototype.mulTo = function (x, y, r) {
      x.multiplyTo(y, r);
      this.reduce(r);
    };
    bg.prototype.sqrTo = function (x, r) {
      x.squareTo(r);
      this.reduce(r);
    };
    return bg;
  })();
  var bh = (function () {
    function bh(m) {
      this.m = m;
      this.mp = m.invDigit();
      this.mpl = this.mp & 0x7fff;
      this.mph = this.mp >> 15;
      this.um = (1 << (m.DB - 15)) - 1;
      this.mt2 = 2 * m.t;
    }
    bh.prototype.convert = function (x) {
      var r = nbi();
      x.abs().dlShiftTo(this.m.t, r);
      r.divRemTo(this.m, null, r);
      if (x.s < 0 && r.compareTo(be.ZERO) > 0) {
        this.m.subTo(r, r);
      }
      return r;
    };
    bh.prototype.revert = function (x) {
      var r = nbi();
      x.copyTo(r);
      this.reduce(r);
      return r;
    };
    bh.prototype.reduce = function (x) {
      while (x.t <= this.mt2) {
        x[x.t++] = 0;
      }
      for (var i = 0; i < this.m.t; ++i) {
        var j = x[i] & 0x7fff;
        var a =
          (j * this.mpl +
            (((j * this.mph + (x[i] >> 15) * this.mpl) & this.um) << 15)) &
          x.DM;
        j = i + this.m.t;
        x[j] += this.m.am(0, a, x, i, 0, this.m.t);
        while (x[j] >= x.DV) {
          x[j] -= x.DV;
          x[++j]++;
        }
      }
      x.clamp();
      x.drShiftTo(this.m.t, x);
      if (x.compareTo(this.m) >= 0) {
        x.subTo(this.m, x);
      }
    };
    bh.prototype.mulTo = function (x, y, r) {
      x.multiplyTo(y, r);
      this.reduce(r);
    };
    bh.prototype.sqrTo = function (x, r) {
      x.squareTo(r);
      this.reduce(r);
    };
    return bh;
  })();
  var bi = (function () {
    function bi(m) {
      this.m = m;
      this.r2 = nbi();
      this.q3 = nbi();
      be.ONE.dlShiftTo(2 * m.t, this.r2);
      this.mu = this.r2.divide(m);
    }
    bi.prototype.convert = function (x) {
      if (x.s < 0 || x.t > 2 * this.m.t) {
        return x.mod(this.m);
      } else if (x.compareTo(this.m) < 0) {
        return x;
      } else {
        var r = nbi();
        x.copyTo(r);
        this.reduce(r);
        return r;
      }
    };
    bi.prototype.revert = function (x) {
      return x;
    };
    bi.prototype.reduce = function (x) {
      x.drShiftTo(this.m.t - 1, this.r2);
      if (x.t > this.m.t + 1) {
        x.t = this.m.t + 1;
        x.clamp();
      }
      this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3);
      this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);
      while (x.compareTo(this.r2) < 0) {
        x.dAddOffset(1, this.m.t + 1);
      }
      x.subTo(this.r2, x);
      while (x.compareTo(this.m) >= 0) {
        x.subTo(this.m, x);
      }
    };
    bi.prototype.mulTo = function (x, y, r) {
      x.multiplyTo(y, r);
      this.reduce(r);
    };
    bi.prototype.sqrTo = function (x, r) {
      x.squareTo(r);
      this.reduce(r);
    };
    return bi;
  })();
  function nbi() {
    return new be(null);
  }
  function parseBigInt(a, r) {
    return new be(a, r);
  }
  function am1(i, x, w, j, c, n) {
    while (--n >= 0) {
      var v = x * this[i++] + w[j] + c;
      c = Math.floor(v / 0x4000000);
      w[j++] = v & 0x3ffffff;
    }
    return c;
  }
  function am2(i, x, w, j, c, n) {
    var a = x & 0x7fff;
    var b = x >> 15;
    while (--n >= 0) {
      var l = this[i] & 0x7fff;
      var h = this[i++] >> 15;
      var m = b * l + h * a;
      l = a * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
      c = (l >>> 30) + (m >>> 15) + b * h + (c >>> 30);
      w[j++] = l & 0x3fffffff;
    }
    return c;
  }
  function am3(i, x, w, j, c, n) {
    var a = x & 0x3fff;
    var b = x >> 14;
    while (--n >= 0) {
      var l = this[i] & 0x3fff;
      var h = this[i++] >> 14;
      var m = b * l + h * a;
      l = a * l + ((m & 0x3fff) << 14) + w[j] + c;
      c = (l >> 28) + (m >> 14) + b * h;
      w[j++] = l & 0xfffffff;
    }
    return c;
  }
  be.prototype.am = am3;
  Z = 28;
  be.prototype.DB = Z;
  be.prototype.DM = (1 << Z) - 1;
  be.prototype.DV = 1 << Z;
  var bj = 52;
  be.prototype.FV = Math.pow(2, bj);
  be.prototype.F1 = bj - Z;
  be.prototype.F2 = 2 * Z - bj;
  var bk = [];
  var bl;
  var bm;
  bl = '0'.charCodeAt(0);
  for (bm = 0; bm <= 9; ++bm) {
    bk[bl++] = bm;
  }
  bl = 'a'.charCodeAt(0);
  for (bm = 10; bm < 36; ++bm) {
    bk[bl++] = bm;
  }
  bl = 'A'.charCodeAt(0);
  for (bm = 10; bm < 36; ++bm) {
    bk[bl++] = bm;
  }
  function intAt(s, i) {
    var c = bk[s.charCodeAt(i)];
    return c == null ? -1 : c;
  }
  function nbv(i) {
    var r = nbi();
    r.fromInt(i);
    return r;
  }
  function nbits(x) {
    var r = 1;
    var t;
    if ((t = x >>> 16) != 0) {
      x = t;
      r += 16;
    }
    if ((t = x >> 8) != 0) {
      x = t;
      r += 8;
    }
    if ((t = x >> 4) != 0) {
      x = t;
      r += 4;
    }
    if ((t = x >> 2) != 0) {
      x = t;
      r += 2;
    }
    if ((t = x >> 1) != 0) {
      x = t;
      r += 1;
    }
    return r;
  }
  be.ZERO = nbv(0);
  be.ONE = nbv(1);
  var bn = (function () {
    function bn() {
      this.i = 0;
      this.j = 0;
      this.S = [];
    }
    bn.prototype.init = function (a) {
      var i;
      var j;
      var t;
      for (i = 0; i < 256; ++i) {
        this.S[i] = i;
      }
      j = 0;
      for (i = 0; i < 256; ++i) {
        j = (j + this.S[i] + a[i % a.length]) & 255;
        t = this.S[i];
        this.S[i] = this.S[j];
        this.S[j] = t;
      }
      this.i = 0;
      this.j = 0;
    };
    bn.prototype.next = function () {
      var t;
      this.i = (this.i + 1) & 255;
      this.j = (this.j + this.S[this.i]) & 255;
      t = this.S[this.i];
      this.S[this.i] = this.S[this.j];
      this.S[this.j] = t;
      return this.S[(t + this.S[this.i]) & 255];
    };
    return bn;
  })();
  function prng_newstate() {
    return new bn();
  }
  var bo = 256;
  var bp;
  var bq = null;
  var br;
  if (bq == null) {
    bq = [];
    br = 0;
    var t = void 0;
    var bs = function (a) {
      for (var i = 0, l = a.length; i < l; i++) {
        a[i] = Math.floor(Math.random() * 256);
      }
      return a;
    };
    var z = new Uint32Array(256);
    bs(z);
    var bt = function (a) {
      this.count = this.count || 0;
      if (this.count >= 256 || br >= bo) {
        return;
      }
      try {
        var b = a.x + a.y;
        bq[br++] = b & 255;
        this.count += 1;
      } catch (e) {}
    };
  }
  function rng_get_byte() {
    if (bp == null) {
      bp = prng_newstate();
      while (br < bo) {
        var a = Math.floor(65536 * Math.random());
        bq[br++] = a & 255;
      }
      bp.init(bq);
      for (br = 0; br < bq.length; ++br) {
        bq[br] = 0;
      }
      br = 0;
    }
    return bp.next();
  }
  var bu = (function () {
    function bu() {}
    bu.prototype.nextBytes = function (a) {
      for (var i = 0; i < a.length; ++i) {
        a[i] = rng_get_byte();
      }
    };
    return bu;
  })();
  function pkcs1pad1(s, n) {
    if (n < s.length + 22) {
      console.error('Message too long for RSA');
      return null;
    }
    var a = n - s.length - 6;
    var b = '';
    for (var f = 0; f < a; f += 2) {
      b += 'ff';
    }
    var m = '0001' + b + '00' + s;
    return parseBigInt(m, 16);
  }
  function pkcs1pad2(s, n) {
    if (n < s.length + 11) {
      console.error('Message too long for RSA');
      return null;
    }
    var a = [];
    var i = s.length - 1;
    while (i >= 0 && n > 0) {
      var c = s.charCodeAt(i--);
      if (c < 128) {
        a[--n] = c;
      } else if (c > 127 && c < 2048) {
        a[--n] = (c & 63) | 128;
        a[--n] = (c >> 6) | 192;
      } else {
        a[--n] = (c & 63) | 128;
        a[--n] = ((c >> 6) & 63) | 128;
        a[--n] = (c >> 12) | 224;
      }
    }
    a[--n] = 0;
    var b = new bu();
    var x = [];
    while (n > 2) {
      x[0] = 0;
      while (x[0] == 0) {
        b.nextBytes(x);
      }
      a[--n] = x[0];
    }
    a[--n] = 2;
    a[--n] = 0;
    return new be(a);
  }
  var bv = (function () {
    function bv() {
      this.n = null;
      this.e = 0;
      this.d = null;
      this.p = null;
      this.q = null;
      this.dmp1 = null;
      this.dmq1 = null;
      this.coeff = null;
    }
    bv.prototype.doPublic = function (x) {
      return x.modPowInt(this.e, this.n);
    };
    bv.prototype.doPrivate = function (x) {
      if (this.p == null || this.q == null) {
        return x.modPow(this.d, this.n);
      }
      var a = x.mod(this.p).modPow(this.dmp1, this.p);
      var b = x.mod(this.q).modPow(this.dmq1, this.q);
      while (a.compareTo(b) < 0) {
        a = a.add(this.p);
      }
      return a
        .subtract(b)
        .multiply(this.coeff)
        .mod(this.p)
        .multiply(this.q)
        .add(b);
    };
    bv.prototype.setPublic = function (N, E) {
      if (N != null && E != null && N.length > 0 && E.length > 0) {
        this.n = parseBigInt(N, 16);
        this.e = parseInt(E, 16);
      } else {
        console.error('Invalid RSA public key');
      }
    };
    bv.prototype.encrypt = function (a) {
      var m = pkcs1pad2(a, (this.n.bitLength() + 7) >> 3);
      if (m == null) {
        return null;
      }
      var c = this.doPublic(m);
      if (c == null) {
        return null;
      }
      var h = c.toString(16);
      if ((h.length & 1) == 0) {
        return h;
      } else {
        return '0' + h;
      }
    };
    bv.prototype.setPrivate = function (N, E, D) {
      if (N != null && E != null && N.length > 0 && E.length > 0) {
        this.n = parseBigInt(N, 16);
        this.e = parseInt(E, 16);
        this.d = parseBigInt(D, 16);
      } else {
        console.error('Invalid RSA private key');
      }
    };
    bv.prototype.setPrivateEx = function (N, E, D, P, Q, a, b, C) {
      if (N != null && E != null && N.length > 0 && E.length > 0) {
        this.n = parseBigInt(N, 16);
        this.e = parseInt(E, 16);
        this.d = parseBigInt(D, 16);
        this.p = parseBigInt(P, 16);
        this.q = parseBigInt(Q, 16);
        this.dmp1 = parseBigInt(a, 16);
        this.dmq1 = parseBigInt(b, 16);
        this.coeff = parseBigInt(C, 16);
      } else {
        console.error('Invalid RSA private key');
      }
    };
    bv.prototype.generate = function (B, E) {
      var a = new bu();
      var b = B >> 1;
      this.e = parseInt(E, 16);
      var c = new be(E, 16);
      for (;;) {
        for (;;) {
          this.p = new be(B - b, 1, a);
          if (
            this.p.subtract(be.ONE).gcd(c).compareTo(be.ONE) == 0 &&
            this.p.isProbablePrime(10)
          ) {
            break;
          }
        }
        for (;;) {
          this.q = new be(b, 1, a);
          if (
            this.q.subtract(be.ONE).gcd(c).compareTo(be.ONE) == 0 &&
            this.q.isProbablePrime(10)
          ) {
            break;
          }
        }
        if (this.p.compareTo(this.q) <= 0) {
          var t = this.p;
          this.p = this.q;
          this.q = t;
        }
        var d = this.p.subtract(be.ONE);
        var e = this.q.subtract(be.ONE);
        var f = d.multiply(e);
        if (f.gcd(c).compareTo(be.ONE) == 0) {
          this.n = this.p.multiply(this.q);
          this.d = c.modInverse(f);
          this.dmp1 = this.d.mod(d);
          this.dmq1 = this.d.mod(e);
          this.coeff = this.q.modInverse(this.p);
          break;
        }
      }
    };
    bv.prototype.decrypt = function (a) {
      var c = parseBigInt(a, 16);
      var m = this.doPublic(c);
      if (m == null) {
        return null;
      }
      return pkcs1unpad2(m, (this.n.bitLength() + 7) >> 3);
    };
    bv.prototype.generateAsync = function (B, E, g) {
      var h = new bu();
      var i = B >> 1;
      this.e = parseInt(E, 16);
      var j = new be(E, 16);
      var k = this;
      var l = function () {
        var d = function () {
          if (k.p.compareTo(k.q) <= 0) {
            var t = k.p;
            k.p = k.q;
            k.q = t;
          }
          var a = k.p.subtract(be.ONE);
          var b = k.q.subtract(be.ONE);
          var c = a.multiply(b);
          if (c.gcd(j).compareTo(be.ONE) == 0) {
            k.n = k.p.multiply(k.q);
            k.d = j.modInverse(c);
            k.dmp1 = k.d.mod(a);
            k.dmq1 = k.d.mod(b);
            k.coeff = k.q.modInverse(k.p);
            setTimeout(function () {
              g();
            }, 0);
          } else {
            setTimeout(l, 0);
          }
        };
        var e = function () {
          k.q = nbi();
          k.q.fromNumberAsync(i, 1, h, function () {
            k.q.subtract(be.ONE).gcda(j, function (r) {
              if (r.compareTo(be.ONE) == 0 && k.q.isProbablePrime(10)) {
                setTimeout(d, 0);
              } else {
                setTimeout(e, 0);
              }
            });
          });
        };
        var f = function () {
          k.p = nbi();
          k.p.fromNumberAsync(B - i, 1, h, function () {
            k.p.subtract(be.ONE).gcda(j, function (r) {
              if (r.compareTo(be.ONE) == 0 && k.p.isProbablePrime(10)) {
                setTimeout(e, 0);
              } else {
                setTimeout(f, 0);
              }
            });
          });
        };
        setTimeout(f, 0);
      };
      setTimeout(l, 0);
    };
    bv.prototype.sign = function (a, b, d) {
      var e = getDigestHeader(d);
      var f = e + b(a).toString();
      var m = pkcs1pad1(f, this.n.bitLength() / 4);
      if (m == null) {
        return null;
      }
      var c = this.doPrivate(m);
      if (c == null) {
        return null;
      }
      var h = c.toString(16);
      if ((h.length & 1) == 0) {
        return h;
      } else {
        return '0' + h;
      }
    };
    bv.prototype.verify = function (a, b, d) {
      var c = parseBigInt(b, 16);
      var m = this.doPublic(c);
      if (m == null) {
        return null;
      }
      var e = m.toString(16).replace(/^1f+00/, '');
      var f = removeDigestHeader(e);
      return f == d(a).toString();
    };
    return bv;
  })();
  function pkcs1unpad2(d, n) {
    var b = d.toByteArray();
    var i = 0;
    while (i < b.length && b[i] == 0) {
      ++i;
    }
    ++i;
    while (b[i] != 0) {
      if (++i >= b.length) {
        return null;
      }
    }
    var a = '';
    while (++i < b.length) {
      var c = b[i] & 255;
      if (c < 128) {
        a += String.fromCharCode(c);
      } else if (c > 191 && c < 224) {
        a += String.fromCharCode(((c & 31) << 6) | (b[i + 1] & 63));
        ++i;
      } else {
        a += String.fromCharCode(
          ((c & 15) << 12) | ((b[i + 1] & 63) << 6) | (b[i + 2] & 63),
        );
        i += 2;
      }
    }
    return a;
  }
  var bw = {
    md2: '3020300c06082a864886f70d020205000410',
    md5: '3020300c06082a864886f70d020505000410',
    sha1: '3021300906052b0e03021a05000414',
    sha224: '302d300d06096086480165030402040500041c',
    sha256: '3031300d060960864801650304020105000420',
    sha384: '3041300d060960864801650304020205000430',
    sha512: '3051300d060960864801650304020305000440',
    ripemd160: '3021300906052b2403020105000414',
  };
  function getDigestHeader(a) {
    return bw[a] || '';
  }
  function removeDigestHeader(a) {
    for (var b in bw) {
      if (bw.hasOwnProperty(b)) {
        var c = bw[b];
        var d = c.length;
        if (a.substr(0, d) == c) {
          return a.substr(d);
        }
      }
    }
    return a;
  }
  var bx = {};
  bx.lang = {
    extend: function (a, b, c) {
      if (!b || !a) {
        throw new Error(
          'YAHOO.lang.extend failed, please check that ' +
            'all dependencies are included.',
        );
      }
      var F = function () {};
      F.prototype = b.prototype;
      a.prototype = new F();
      a.prototype.constructor = a;
      a.superclass = b.prototype;
      if (b.prototype.constructor == Object.prototype.constructor) {
        b.prototype.constructor = b;
      }
      if (c) {
        var i;
        for (i in c) {
          a.prototype[i] = c[i];
        }
        var d = function () {},
          ADD = ['toString', 'valueOf'];
        d(a.prototype, c);
      }
    },
  };
  var by = {};
  if (typeof by.asn1 == 'undefined' || !by.asn1) by.asn1 = {};
  by.asn1.ASN1Util = new (function () {
    this.integerToByteHex = function (i) {
      var h = i.toString(16);
      if (h.length % 2 == 1) h = '0' + h;
      return h;
    };
    this.bigIntToMinTwosComplementsHex = function (a) {
      var h = a.toString(16);
      if (h.substr(0, 1) != '-') {
        if (h.length % 2 == 1) {
          h = '0' + h;
        } else {
          if (!h.match(/^[0-7]/)) {
            h = '00' + h;
          }
        }
      } else {
        var b = h.substr(1);
        var c = b.length;
        if (c % 2 == 1) {
          c += 1;
        } else {
          if (!h.match(/^[0-7]/)) {
            c += 2;
          }
        }
        var d = '';
        for (var i = 0; i < c; i++) {
          d += 'f';
        }
        var e = new be(d, 16);
        var f = e.xor(a).add(be.ONE);
        h = f.toString(16).replace(/^-/, '');
      }
      return h;
    };
    this.getPEMStringFromHex = function (a, b) {
      return hextopem(a, b);
    };
    this.newObject = function (b) {
      var c = by,
        _KJUR_asn1 = c.asn1,
        _DERBoolean = _KJUR_asn1.DERBoolean,
        _DERInteger = _KJUR_asn1.DERInteger,
        _DERBitString = _KJUR_asn1.DERBitString,
        _DEROctetString = _KJUR_asn1.DEROctetString,
        _DERNull = _KJUR_asn1.DERNull,
        _DERObjectIdentifier = _KJUR_asn1.DERObjectIdentifier,
        _DEREnumerated = _KJUR_asn1.DEREnumerated,
        _DERUTF8String = _KJUR_asn1.DERUTF8String,
        _DERNumericString = _KJUR_asn1.DERNumericString,
        _DERPrintableString = _KJUR_asn1.DERPrintableString,
        _DERTeletexString = _KJUR_asn1.DERTeletexString,
        _DERIA5String = _KJUR_asn1.DERIA5String,
        _DERUTCTime = _KJUR_asn1.DERUTCTime,
        _DERGeneralizedTime = _KJUR_asn1.DERGeneralizedTime,
        _DERSequence = _KJUR_asn1.DERSequence,
        _DERSet = _KJUR_asn1.DERSet,
        _DERTaggedObject = _KJUR_asn1.DERTaggedObject,
        _newObject = _KJUR_asn1.ASN1Util.newObject;
      var d = Object.keys(b);
      if (d.length != 1) throw 'key of param shall be only one.';
      var e = d[0];
      if (
        ':bool:int:bitstr:octstr:null:oid:enum:utf8str:numstr:prnstr:telstr:ia5str:utctime:gentime:seq:set:tag:'.indexOf(
          ':' + e + ':',
        ) == -1
      )
        throw 'undefined key: ' + e;
      if (e == 'bool') return new _DERBoolean(b[e]);
      if (e == 'int') return new _DERInteger(b[e]);
      if (e == 'bitstr') return new _DERBitString(b[e]);
      if (e == 'octstr') return new _DEROctetString(b[e]);
      if (e == 'null') return new _DERNull(b[e]);
      if (e == 'oid') return new _DERObjectIdentifier(b[e]);
      if (e == 'enum') return new _DEREnumerated(b[e]);
      if (e == 'utf8str') return new _DERUTF8String(b[e]);
      if (e == 'numstr') return new _DERNumericString(b[e]);
      if (e == 'prnstr') return new _DERPrintableString(b[e]);
      if (e == 'telstr') return new _DERTeletexString(b[e]);
      if (e == 'ia5str') return new _DERIA5String(b[e]);
      if (e == 'utctime') return new _DERUTCTime(b[e]);
      if (e == 'gentime') return new _DERGeneralizedTime(b[e]);
      if (e == 'seq') {
        var f = b[e];
        var a = [];
        for (var i = 0; i < f.length; i++) {
          var g = _newObject(f[i]);
          a.push(g);
        }
        return new _DERSequence({ array: a });
      }
      if (e == 'set') {
        var f = b[e];
        var a = [];
        for (var i = 0; i < f.length; i++) {
          var g = _newObject(f[i]);
          a.push(g);
        }
        return new _DERSet({ array: a });
      }
      if (e == 'tag') {
        var h = b[e];
        if (
          Object.prototype.toString.call(h) === '[object Array]' &&
          h.length == 3
        ) {
          var j = _newObject(h[2]);
          return new _DERTaggedObject({
            tag: h[0],
            explicit: h[1],
            obj: j,
          });
        } else {
          var k = {};
          if (h.explicit !== undefined) k.explicit = h.explicit;
          if (h.tag !== undefined) k.tag = h.tag;
          if (h.obj === undefined) throw "obj shall be specified for 'tag'.";
          k.obj = _newObject(h.obj);
          return new _DERTaggedObject(k);
        }
      }
    };
    this.jsonToASN1HEX = function (a) {
      var b = this.newObject(a);
      return b.getEncodedHex();
    };
  })();
  by.asn1.ASN1Util.oidHexToInt = function (a) {
    var s = '';
    var b = parseInt(a.substr(0, 2), 16);
    var c = Math.floor(b / 40);
    var d = b % 40;
    var s = c + '.' + d;
    var e = '';
    for (var i = 2; i < a.length; i += 2) {
      var f = parseInt(a.substr(i, 2), 16);
      var g = ('00000000' + f.toString(2)).slice(-8);
      e = e + g.substr(1, 7);
      if (g.substr(0, 1) == '0') {
        var h = new be(e, 2);
        s = s + '.' + h.toString(10);
        e = '';
      }
    }
    return s;
  };
  by.asn1.ASN1Util.oidIntToHex = function (g) {
    var j = function (i) {
      var h = i.toString(16);
      if (h.length == 1) h = '0' + h;
      return h;
    };
    var k = function (a) {
      var h = '';
      var c = new be(a, 10);
      var b = c.toString(2);
      var d = 7 - (b.length % 7);
      if (d == 7) d = 0;
      var e = '';
      for (var i = 0; i < d; i++) e += '0';
      b = e + b;
      for (var i = 0; i < b.length - 1; i += 7) {
        var f = b.substr(i, 7);
        if (i != b.length - 7) f = '1' + f;
        h += j(parseInt(f, 2));
      }
      return h;
    };
    if (!g.match(/^[0-9.]+$/)) {
      throw 'malformed oid string: ' + g;
    }
    var h = '';
    var a = g.split('.');
    var l = parseInt(a[0]) * 40 + parseInt(a[1]);
    h += j(l);
    a.splice(0, 2);
    for (var i = 0; i < a.length; i++) {
      h += k(a[i]);
    }
    return h;
  };
  by.asn1.ASN1Object = function () {
    var d = '';
    this.getLengthHexFromValue = function () {
      if (typeof this.hV == 'undefined' || this.hV == null) {
        throw 'this.hV is null or undefined.';
      }
      if (this.hV.length % 2 == 1) {
        throw 'value hex must be even length: n=' + d.length + ',v=' + this.hV;
      }
      var n = this.hV.length / 2;
      var a = n.toString(16);
      if (a.length % 2 == 1) {
        a = '0' + a;
      }
      if (n < 128) {
        return a;
      } else {
        var b = a.length / 2;
        if (b > 15) {
          throw (
            'ASN.1 length too long to represent by 8x: n = ' + n.toString(16)
          );
        }
        var c = 128 + b;
        return c.toString(16) + a;
      }
    };
    this.getEncodedHex = function () {
      if (this.hTLV == null || this.isModified) {
        this.hV = this.getFreshValueHex();
        this.hL = this.getLengthHexFromValue();
        this.hTLV = this.hT + this.hL + this.hV;
        this.isModified = false;
      }
      return this.hTLV;
    };
    this.getValueHex = function () {
      this.getEncodedHex();
      return this.hV;
    };
    this.getFreshValueHex = function () {
      return '';
    };
  };
  by.asn1.DERAbstractString = function (b) {
    by.asn1.DERAbstractString.superclass.constructor.call(this);
    this.getString = function () {
      return this.s;
    };
    this.setString = function (a) {
      this.hTLV = null;
      this.isModified = true;
      this.s = a;
      this.hV = stohex(this.s);
    };
    this.setStringHex = function (a) {
      this.hTLV = null;
      this.isModified = true;
      this.s = null;
      this.hV = a;
    };
    this.getFreshValueHex = function () {
      return this.hV;
    };
    if (typeof b != 'undefined') {
      if (typeof b == 'string') {
        this.setString(b);
      } else if (typeof b['str'] != 'undefined') {
        this.setString(b['str']);
      } else if (typeof b['hex'] != 'undefined') {
        this.setStringHex(b['hex']);
      }
    }
  };
  bx.lang.extend(by.asn1.DERAbstractString, by.asn1.ASN1Object);
  by.asn1.DERAbstractTime = function (n) {
    by.asn1.DERAbstractTime.superclass.constructor.call(this);
    this.localDateToUTC = function (d) {
      utc = d.getTime() + d.getTimezoneOffset() * 60000;
      var a = new Date(utc);
      return a;
    };
    this.formatDate = function (a, b, c) {
      var e = this.zeroPadding;
      var d = this.localDateToUTC(a);
      var f = String(d.getFullYear());
      if (b == 'utc') f = f.substr(2, 2);
      var g = e(String(d.getMonth() + 1), 2);
      var h = e(String(d.getDate()), 2);
      var i = e(String(d.getHours()), 2);
      var j = e(String(d.getMinutes()), 2);
      var k = e(String(d.getSeconds()), 2);
      var s = f + g + h + i + j + k;
      if (c === true) {
        var l = d.getMilliseconds();
        if (l != 0) {
          var m = e(String(l), 3);
          m = m.replace(/[0]+$/, '');
          s = s + '.' + m;
        }
      }
      return s + 'Z';
    };
    this.zeroPadding = function (s, a) {
      if (s.length >= a) return s;
      return new Array(a - s.length + 1).join('0') + s;
    };
    this.getString = function () {
      return this.s;
    };
    this.setString = function (a) {
      this.hTLV = null;
      this.isModified = true;
      this.s = a;
      this.hV = stohex(a);
    };
    this.setByDateValue = function (a, b, c, d, e, f) {
      var g = new Date(Date.UTC(a, b - 1, c, d, e, f, 0));
      this.setByDate(g);
    };
    this.getFreshValueHex = function () {
      return this.hV;
    };
  };
  bx.lang.extend(by.asn1.DERAbstractTime, by.asn1.ASN1Object);
  by.asn1.DERAbstractStructured = function (b) {
    by.asn1.DERAbstractString.superclass.constructor.call(this);
    this.setByASN1ObjectArray = function (a) {
      this.hTLV = null;
      this.isModified = true;
      this.asn1Array = a;
    };
    this.appendASN1Object = function (a) {
      this.hTLV = null;
      this.isModified = true;
      this.asn1Array.push(a);
    };
    this.asn1Array = new Array();
    if (typeof b != 'undefined') {
      if (typeof b['array'] != 'undefined') {
        this.asn1Array = b['array'];
      }
    }
  };
  bx.lang.extend(by.asn1.DERAbstractStructured, by.asn1.ASN1Object);
  by.asn1.DERBoolean = function () {
    by.asn1.DERBoolean.superclass.constructor.call(this);
    this.hT = '01';
    this.hTLV = '0101ff';
  };
  bx.lang.extend(by.asn1.DERBoolean, by.asn1.ASN1Object);
  by.asn1.DERInteger = function (c) {
    by.asn1.DERInteger.superclass.constructor.call(this);
    this.hT = '02';
    this.setByBigInteger = function (a) {
      this.hTLV = null;
      this.isModified = true;
      this.hV = by.asn1.ASN1Util.bigIntToMinTwosComplementsHex(a);
    };
    this.setByInteger = function (a) {
      var b = new be(String(a), 10);
      this.setByBigInteger(b);
    };
    this.setValueHex = function (a) {
      this.hV = a;
    };
    this.getFreshValueHex = function () {
      return this.hV;
    };
    if (typeof c != 'undefined') {
      if (typeof c['bigint'] != 'undefined') {
        this.setByBigInteger(c['bigint']);
      } else if (typeof c['int'] != 'undefined') {
        this.setByInteger(c['int']);
      } else if (typeof c == 'number') {
        this.setByInteger(c);
      } else if (typeof c['hex'] != 'undefined') {
        this.setValueHex(c['hex']);
      }
    }
  };
  bx.lang.extend(by.asn1.DERInteger, by.asn1.ASN1Object);
  by.asn1.DERBitString = function (d) {
    if (d !== undefined && typeof d.obj !== 'undefined') {
      var o = by.asn1.ASN1Util.newObject(d.obj);
      d.hex = '00' + o.getEncodedHex();
    }
    by.asn1.DERBitString.superclass.constructor.call(this);
    this.hT = '03';
    this.setHexValueIncludingUnusedBits = function (a) {
      this.hTLV = null;
      this.isModified = true;
      this.hV = a;
    };
    this.setUnusedBitsAndHexValue = function (a, b) {
      if (a < 0 || 7 < a) {
        throw 'unused bits shall be from 0 to 7: u = ' + a;
      }
      var c = '0' + a;
      this.hTLV = null;
      this.isModified = true;
      this.hV = c + b;
    };
    this.setByBinaryString = function (a) {
      a = a.replace(/0+$/, '');
      var c = 8 - (a.length % 8);
      if (c == 8) c = 0;
      for (var i = 0; i <= c; i++) {
        a += '0';
      }
      var h = '';
      for (var i = 0; i < a.length - 1; i += 8) {
        var b = a.substr(i, 8);
        var x = parseInt(b, 2).toString(16);
        if (x.length == 1) x = '0' + x;
        h += x;
      }
      this.hTLV = null;
      this.isModified = true;
      this.hV = '0' + c + h;
    };
    this.setByBooleanArray = function (a) {
      var s = '';
      for (var i = 0; i < a.length; i++) {
        if (a[i] == true) {
          s += '1';
        } else {
          s += '0';
        }
      }
      this.setByBinaryString(s);
    };
    this.newFalseArray = function (b) {
      var a = new Array(b);
      for (var i = 0; i < b; i++) {
        a[i] = false;
      }
      return a;
    };
    this.getFreshValueHex = function () {
      return this.hV;
    };
    if (typeof d != 'undefined') {
      if (typeof d == 'string' && d.toLowerCase().match(/^[0-9a-f]+$/)) {
        this.setHexValueIncludingUnusedBits(d);
      } else if (typeof d['hex'] != 'undefined') {
        this.setHexValueIncludingUnusedBits(d['hex']);
      } else if (typeof d['bin'] != 'undefined') {
        this.setByBinaryString(d['bin']);
      } else if (typeof d['array'] != 'undefined') {
        this.setByBooleanArray(d['array']);
      }
    }
  };
  bx.lang.extend(by.asn1.DERBitString, by.asn1.ASN1Object);
  by.asn1.DEROctetString = function (a) {
    if (a !== undefined && typeof a.obj !== 'undefined') {
      var o = by.asn1.ASN1Util.newObject(a.obj);
      a.hex = o.getEncodedHex();
    }
    by.asn1.DEROctetString.superclass.constructor.call(this, a);
    this.hT = '04';
  };
  bx.lang.extend(by.asn1.DEROctetString, by.asn1.DERAbstractString);
  by.asn1.DERNull = function () {
    by.asn1.DERNull.superclass.constructor.call(this);
    this.hT = '05';
    this.hTLV = '0500';
  };
  bx.lang.extend(by.asn1.DERNull, by.asn1.ASN1Object);
  by.asn1.DERObjectIdentifier = function (g) {
    var j = function (i) {
      var h = i.toString(16);
      if (h.length == 1) h = '0' + h;
      return h;
    };
    var k = function (a) {
      var h = '';
      var c = new be(a, 10);
      var b = c.toString(2);
      var d = 7 - (b.length % 7);
      if (d == 7) d = 0;
      var e = '';
      for (var i = 0; i < d; i++) e += '0';
      b = e + b;
      for (var i = 0; i < b.length - 1; i += 7) {
        var f = b.substr(i, 7);
        if (i != b.length - 7) f = '1' + f;
        h += j(parseInt(f, 2));
      }
      return h;
    };
    by.asn1.DERObjectIdentifier.superclass.constructor.call(this);
    this.hT = '06';
    this.setValueHex = function (a) {
      this.hTLV = null;
      this.isModified = true;
      this.s = null;
      this.hV = a;
    };
    this.setValueOidString = function (b) {
      if (!b.match(/^[0-9.]+$/)) {
        throw 'malformed oid string: ' + b;
      }
      var h = '';
      var a = b.split('.');
      var c = parseInt(a[0]) * 40 + parseInt(a[1]);
      h += j(c);
      a.splice(0, 2);
      for (var i = 0; i < a.length; i++) {
        h += k(a[i]);
      }
      this.hTLV = null;
      this.isModified = true;
      this.s = null;
      this.hV = h;
    };
    this.setValueName = function (a) {
      var b = by.asn1.x509.OID.name2oid(a);
      if (b !== '') {
        this.setValueOidString(b);
      } else {
        throw 'DERObjectIdentifier oidName undefined: ' + a;
      }
    };
    this.getFreshValueHex = function () {
      return this.hV;
    };
    if (g !== undefined) {
      if (typeof g === 'string') {
        if (g.match(/^[0-2].[0-9.]+$/)) {
          this.setValueOidString(g);
        } else {
          this.setValueName(g);
        }
      } else if (g.oid !== undefined) {
        this.setValueOidString(g.oid);
      } else if (g.hex !== undefined) {
        this.setValueHex(g.hex);
      } else if (g.name !== undefined) {
        this.setValueName(g.name);
      }
    }
  };
  bx.lang.extend(by.asn1.DERObjectIdentifier, by.asn1.ASN1Object);
  by.asn1.DEREnumerated = function (c) {
    by.asn1.DEREnumerated.superclass.constructor.call(this);
    this.hT = '0a';
    this.setByBigInteger = function (a) {
      this.hTLV = null;
      this.isModified = true;
      this.hV = by.asn1.ASN1Util.bigIntToMinTwosComplementsHex(a);
    };
    this.setByInteger = function (a) {
      var b = new be(String(a), 10);
      this.setByBigInteger(b);
    };
    this.setValueHex = function (a) {
      this.hV = a;
    };
    this.getFreshValueHex = function () {
      return this.hV;
    };
    if (typeof c != 'undefined') {
      if (typeof c['int'] != 'undefined') {
        this.setByInteger(c['int']);
      } else if (typeof c == 'number') {
        this.setByInteger(c);
      } else if (typeof c['hex'] != 'undefined') {
        this.setValueHex(c['hex']);
      }
    }
  };
  bx.lang.extend(by.asn1.DEREnumerated, by.asn1.ASN1Object);
  by.asn1.DERUTF8String = function (a) {
    by.asn1.DERUTF8String.superclass.constructor.call(this, a);
    this.hT = '0c';
  };
  bx.lang.extend(by.asn1.DERUTF8String, by.asn1.DERAbstractString);
  by.asn1.DERNumericString = function (a) {
    by.asn1.DERNumericString.superclass.constructor.call(this, a);
    this.hT = '12';
  };
  bx.lang.extend(by.asn1.DERNumericString, by.asn1.DERAbstractString);
  by.asn1.DERPrintableString = function (a) {
    by.asn1.DERPrintableString.superclass.constructor.call(this, a);
    this.hT = '13';
  };
  bx.lang.extend(by.asn1.DERPrintableString, by.asn1.DERAbstractString);
  by.asn1.DERTeletexString = function (a) {
    by.asn1.DERTeletexString.superclass.constructor.call(this, a);
    this.hT = '14';
  };
  bx.lang.extend(by.asn1.DERTeletexString, by.asn1.DERAbstractString);
  by.asn1.DERIA5String = function (a) {
    by.asn1.DERIA5String.superclass.constructor.call(this, a);
    this.hT = '16';
  };
  bx.lang.extend(by.asn1.DERIA5String, by.asn1.DERAbstractString);
  by.asn1.DERUTCTime = function (b) {
    by.asn1.DERUTCTime.superclass.constructor.call(this, b);
    this.hT = '17';
    this.setByDate = function (a) {
      this.hTLV = null;
      this.isModified = true;
      this.date = a;
      this.s = this.formatDate(this.date, 'utc');
      this.hV = stohex(this.s);
    };
    this.getFreshValueHex = function () {
      if (typeof this.date == 'undefined' && typeof this.s == 'undefined') {
        this.date = new Date();
        this.s = this.formatDate(this.date, 'utc');
        this.hV = stohex(this.s);
      }
      return this.hV;
    };
    if (b !== undefined) {
      if (b.str !== undefined) {
        this.setString(b.str);
      } else if (typeof b == 'string' && b.match(/^[0-9]{12}Z$/)) {
        this.setString(b);
      } else if (b.hex !== undefined) {
        this.setStringHex(b.hex);
      } else if (b.date !== undefined) {
        this.setByDate(b.date);
      }
    }
  };
  bx.lang.extend(by.asn1.DERUTCTime, by.asn1.DERAbstractTime);
  by.asn1.DERGeneralizedTime = function (b) {
    by.asn1.DERGeneralizedTime.superclass.constructor.call(this, b);
    this.hT = '18';
    this.withMillis = false;
    this.setByDate = function (a) {
      this.hTLV = null;
      this.isModified = true;
      this.date = a;
      this.s = this.formatDate(this.date, 'gen', this.withMillis);
      this.hV = stohex(this.s);
    };
    this.getFreshValueHex = function () {
      if (this.date === undefined && this.s === undefined) {
        this.date = new Date();
        this.s = this.formatDate(this.date, 'gen', this.withMillis);
        this.hV = stohex(this.s);
      }
      return this.hV;
    };
    if (b !== undefined) {
      if (b.str !== undefined) {
        this.setString(b.str);
      } else if (typeof b == 'string' && b.match(/^[0-9]{14}Z$/)) {
        this.setString(b);
      } else if (b.hex !== undefined) {
        this.setStringHex(b.hex);
      } else if (b.date !== undefined) {
        this.setByDate(b.date);
      }
      if (b.millis === true) {
        this.withMillis = true;
      }
    }
  };
  bx.lang.extend(by.asn1.DERGeneralizedTime, by.asn1.DERAbstractTime);
  by.asn1.DERSequence = function (b) {
    by.asn1.DERSequence.superclass.constructor.call(this, b);
    this.hT = '30';
    this.getFreshValueHex = function () {
      var h = '';
      for (var i = 0; i < this.asn1Array.length; i++) {
        var a = this.asn1Array[i];
        h += a.getEncodedHex();
      }
      this.hV = h;
      return this.hV;
    };
  };
  bx.lang.extend(by.asn1.DERSequence, by.asn1.DERAbstractStructured);
  by.asn1.DERSet = function (c) {
    by.asn1.DERSet.superclass.constructor.call(this, c);
    this.hT = '31';
    this.sortFlag = true;
    this.getFreshValueHex = function () {
      var a = new Array();
      for (var i = 0; i < this.asn1Array.length; i++) {
        var b = this.asn1Array[i];
        a.push(b.getEncodedHex());
      }
      if (this.sortFlag == true) a.sort();
      this.hV = a.join('');
      return this.hV;
    };
    if (typeof c != 'undefined') {
      if (typeof c.sortflag != 'undefined' && c.sortflag == false)
        this.sortFlag = false;
    }
  };
  bx.lang.extend(by.asn1.DERSet, by.asn1.DERAbstractStructured);
  by.asn1.DERTaggedObject = function (d) {
    by.asn1.DERTaggedObject.superclass.constructor.call(this);
    this.hT = 'a0';
    this.hV = '';
    this.isExplicit = true;
    this.asn1Object = null;
    this.setASN1Object = function (a, b, c) {
      this.hT = b;
      this.isExplicit = a;
      this.asn1Object = c;
      if (this.isExplicit) {
        this.hV = this.asn1Object.getEncodedHex();
        this.hTLV = null;
        this.isModified = true;
      } else {
        this.hV = null;
        this.hTLV = c.getEncodedHex();
        this.hTLV = this.hTLV.replace(/^../, b);
        this.isModified = false;
      }
    };
    this.getFreshValueHex = function () {
      return this.hV;
    };
    if (typeof d != 'undefined') {
      if (typeof d['tag'] != 'undefined') {
        this.hT = d['tag'];
      }
      if (typeof d['explicit'] != 'undefined') {
        this.isExplicit = d['explicit'];
      }
      if (typeof d['obj'] != 'undefined') {
        this.asn1Object = d['obj'];
        this.setASN1Object(this.isExplicit, this.hT, this.asn1Object);
      }
    }
  };
  bx.lang.extend(by.asn1.DERTaggedObject, by.asn1.ASN1Object);
  var bz = (function (o) {
    __extends(bz, o);
    function bz(a) {
      var b = o.call(this) || this;
      if (a) {
        if (typeof a === 'string') {
          b.parseKey(a);
        } else if (bz.hasPrivateKeyProperty(a) || bz.hasPublicKeyProperty(a)) {
          b.parsePropertiesFrom(a);
        }
      }
      return b;
    }
    bz.prototype.parseKey = function (a) {
      try {
        var b = 0;
        var c = 0;
        var d = /^\s*(?:[0-9A-Fa-f][0-9A-Fa-f]\s*)+$/;
        var e = d.test(a) ? L.decode(a) : O.unarmor(a);
        var f = X.decode(e);
        if (f.sub.length === 3) {
          f = f.sub[2].sub[0];
        }
        if (f.sub.length === 9) {
          b = f.sub[1].getHexStringValue();
          this.n = parseBigInt(b, 16);
          c = f.sub[2].getHexStringValue();
          this.e = parseInt(c, 16);
          var g = f.sub[3].getHexStringValue();
          this.d = parseBigInt(g, 16);
          var h = f.sub[4].getHexStringValue();
          this.p = parseBigInt(h, 16);
          var i = f.sub[5].getHexStringValue();
          this.q = parseBigInt(i, 16);
          var j = f.sub[6].getHexStringValue();
          this.dmp1 = parseBigInt(j, 16);
          var k = f.sub[7].getHexStringValue();
          this.dmq1 = parseBigInt(k, 16);
          var l = f.sub[8].getHexStringValue();
          this.coeff = parseBigInt(l, 16);
        } else if (f.sub.length === 2) {
          var m = f.sub[1];
          var n = m.sub[0];
          b = n.sub[0].getHexStringValue();
          this.n = parseBigInt(b, 16);
          c = n.sub[1].getHexStringValue();
          this.e = parseInt(c, 16);
        } else {
          return false;
        }
        return true;
      } catch (ex) {
        return false;
      }
    };
    bz.prototype.getPrivateBaseKey = function () {
      var a = {
        array: [
          new by.asn1.DERInteger({ int: 0 }),
          new by.asn1.DERInteger({ bigint: this.n }),
          new by.asn1.DERInteger({ int: this.e }),
          new by.asn1.DERInteger({ bigint: this.d }),
          new by.asn1.DERInteger({ bigint: this.p }),
          new by.asn1.DERInteger({ bigint: this.q }),
          new by.asn1.DERInteger({ bigint: this.dmp1 }),
          new by.asn1.DERInteger({ bigint: this.dmq1 }),
          new by.asn1.DERInteger({ bigint: this.coeff }),
        ],
      };
      var b = new by.asn1.DERSequence(a);
      return b.getEncodedHex();
    };
    bz.prototype.getPrivateBaseKeyB64 = function () {
      return hex2b64(this.getPrivateBaseKey());
    };
    bz.prototype.getPublicBaseKey = function () {
      var a = new by.asn1.DERSequence({
        array: [
          new by.asn1.DERObjectIdentifier({
            oid: '1.2.840.113549.1.1.1',
          }),
          new by.asn1.DERNull(),
        ],
      });
      var b = new by.asn1.DERSequence({
        array: [
          new by.asn1.DERInteger({ bigint: this.n }),
          new by.asn1.DERInteger({ int: this.e }),
        ],
      });
      var c = new by.asn1.DERBitString({ hex: '00' + b.getEncodedHex() });
      var d = new by.asn1.DERSequence({ array: [a, c] });
      return d.getEncodedHex();
    };
    bz.prototype.getPublicBaseKeyB64 = function () {
      return hex2b64(this.getPublicBaseKey());
    };
    bz.wordwrap = function (a, b) {
      b = b || 64;
      if (!a) {
        return a;
      }
      var c = '(.{1,' + b + '})( +|$\n?)|(.{1,' + b + '})';
      return a.match(RegExp(c, 'g')).join('\n');
    };
    bz.prototype.getPrivateKey = function () {
      var a = '-----BEGIN RSA PRIVATE KEY-----\n';
      a += bz.wordwrap(this.getPrivateBaseKeyB64()) + '\n';
      a += '-----END RSA PRIVATE KEY-----';
      return a;
    };
    bz.prototype.getPublicKey = function () {
      var a = '-----BEGIN PUBLIC KEY-----\n';
      a += bz.wordwrap(this.getPublicBaseKeyB64()) + '\n';
      a += '-----END PUBLIC KEY-----';
      return a;
    };
    bz.hasPublicKeyProperty = function (a) {
      a = a || {};
      return a.hasOwnProperty('n') && a.hasOwnProperty('e');
    };
    bz.hasPrivateKeyProperty = function (a) {
      a = a || {};
      return (
        a.hasOwnProperty('n') &&
        a.hasOwnProperty('e') &&
        a.hasOwnProperty('d') &&
        a.hasOwnProperty('p') &&
        a.hasOwnProperty('q') &&
        a.hasOwnProperty('dmp1') &&
        a.hasOwnProperty('dmq1') &&
        a.hasOwnProperty('coeff')
      );
    };
    bz.prototype.parsePropertiesFrom = function (a) {
      this.n = a.n;
      this.e = a.e;
      if (a.hasOwnProperty('d')) {
        this.d = a.d;
        this.p = a.p;
        this.q = a.q;
        this.dmp1 = a.dmp1;
        this.dmq1 = a.dmq1;
        this.coeff = a.coeff;
      }
    };
    return bz;
  })(bv);
  var bA = (function () {
    function bA(a) {
      a = a || {};
      this.default_key_size = parseInt(a.default_key_size, 10) || 1024;
      this.default_public_exponent = a.default_public_exponent || '010001';
      this.log = a.log || false;
      this.key = null;
    }
    bA.prototype.setKey = function (a) {
      if (this.log && this.key) {
        console.warn('A key was already set, overriding existing.');
      }
      this.key = new bz(a);
    };
    bA.prototype.setPrivateKey = function (a) {
      this.setKey(a);
    };
    bA.prototype.setPublicKey = function (a) {
      this.setKey(a);
    };
    bA.prototype.decrypt = function (a) {
      try {
        return this.getKey().decrypt(b64tohex(a));
      } catch (ex) {
        return false;
      }
    };
    bA.prototype.encrypt = function (a) {
      try {
        return hex2b64(this.getKey().encrypt(a));
      } catch (ex) {
        return false;
      }
    };
    bA.prototype.sign = function (a, b, c) {
      try {
        return hex2b64(this.getKey().sign(a, b, c));
      } catch (ex) {
        return false;
      }
    };
    bA.prototype.verify = function (a, b, c) {
      try {
        return this.getKey().verify(a, b64tohex(b), c);
      } catch (ex) {
        return false;
      }
    };
    bA.prototype.getKey = function (a) {
      if (!this.key) {
        this.key = new bz();
        if (a && {}.toString.call(a) === '[object Function]') {
          this.key.generateAsync(
            this.default_key_size,
            this.default_public_exponent,
            a,
          );
          return;
        }
        this.key.generate(this.default_key_size, this.default_public_exponent);
      }
      return this.key;
    };
    bA.prototype.getPrivateKey = function () {
      return this.getKey().getPrivateKey();
    };
    bA.prototype.getPrivateKeyB64 = function () {
      return this.getKey().getPrivateBaseKeyB64();
    };
    bA.prototype.getPublicKey = function () {
      return this.getKey().getPublicKey();
    };
    bA.prototype.getPublicKeyB64 = function () {
      return this.getKey().getPublicBaseKeyB64();
    };
    bA.version = '3.0.0-rc.1';
    return bA;
  })();
  A.JSEncrypt = bA;
  A.default = bA;
  Object.defineProperty(A, '__esModule', { value: true });
});



// WEBPACK FOOTER //
// ./src/utils/jsencrypt/jsencrypt.min.js